export const translations = {
  // ==================== DEUTSCH ====================
  de: {
    // Gepäcksuche (LuggageSearch)
    'lug.title': 'Gepäckstück suchen',
    'lug.subtitle': 'Finden Sie Ihr Gepäck',
    'lug.searchHint': 'Geben Sie Ihre Ticketnummer ein, um die richtige Abholstation zu finden',
    'lug.ticketLabel': 'Ticket-Nummer',
    'lug.ticketPh': 'z.B. 1234 oder 5678',
    'lug.ticketRange': 'Nummern von 1 bis 12000',
    'lug.findStation': 'Station finden',
    'lug.notFoundTitle': 'Keine Station gefunden',
    'lug.notFoundText': 'Zu dieser Ticketnummer konnte keine Gepäckstation zugeordnet werden. Bitte prüfen Sie die Nummer.',
    'lug.pickupStation': 'Ihre Abholstation',
    'lug.openMaps': 'Google Maps öffnen',
    'lug.cantPickup': 'Nicht abholbar? Versand anfragen',
    'lug.shippingRequest': 'Versandanfrage',
    'lug.personalData': 'Persönliche Daten',
    'lug.fullName': 'Vollständiger Name',
    'lug.emailLabel': 'E-Mail',
    'lug.phoneLabel': 'Telefon',
    'lug.address': 'Adresse',
    'lug.postalCode': 'PLZ',
    'lug.city': 'Stadt',
    'lug.country': 'Land',
    'lug.requiredDocs': 'Erforderliche Dokumente',
    'lug.ticketPhoto': 'Ticket-Foto',
    'lug.ticketPhotoHint': 'Foto oder PDF Ihres Tickets',
    'lug.dhlLabel': 'DHL Versandlabel',
    'lug.dhlBuyHint': 'Sie müssen ein DHL-Label kaufen:',
    'lug.dhlBuy': 'DHL Label kaufen',
    'lug.dhlImportant': 'Wichtig: Achten Sie auf die richtige Größe und das Gewicht für Ihr Gepäckstück!',
    'lug.send': 'Versandanfrage senden',
    'lug.sending': 'Wird gesendet...',
    'lug.cancel': 'Abbrechen',
    'lug.successMsg': 'Versandanfrage erfolgreich eingereicht! Sie erhalten eine Bestätigungs-E-Mail.',
    'lug.refLabel': 'Ihre Referenznummer:',
    'lug.confirmMail': 'Bestätigung geht an:',
    'lug.errRequired': 'Bitte füllen Sie alle Pflichtfelder aus.',
    'lug.errSend': 'Fehler beim Senden der Anfrage',
    'lug.back': 'Zurück zur Startseite',
    // Bewerbung (Register)
    'reg.title': 'Bewerbung',
    'reg.subtitle': 'Oktoberfest Personalplanung',
    'reg.onlyTitle': 'Nur für Bewerber!',
    'reg.onlyText': 'Dieses Formular ist ausschließlich für die Bewerbung als Mitarbeiter/in. Für Rollstuhlservice oder Gepäcksuche bitte die Links auf der Startseite nutzen.',
    'reg.homepage': 'Startseite',
    'reg.firstname': 'Vorname',
    'reg.firstnamePh': 'Ihr Vorname',
    'reg.lastname': 'Nachname',
    'reg.lastnamePh': 'Ihr Nachname',
    'reg.birthdate': 'Geburtsdatum',
    'reg.birthdateHint': 'Dient gleichzeitig als Ihr Passwort für die Anmeldung',
    'reg.phone': 'Telefonnummer',
    'reg.optional': '(optional)',
    'reg.email': 'E-Mail',
    'reg.emailOptional': '(optional, für Bestätigung)',
    'reg.submit': 'Jetzt bewerben',
    'reg.submitting': 'Wird registriert...',
    'reg.alreadyReg': 'Bereits registriert?',
    'reg.toLogin': 'Zur Anmeldung',
    'reg.successTitle': 'Registrierung erfolgreich!',
    'reg.successText': 'Ihr Konto wurde erstellt. Sie können sich jetzt mit Ihrem Nachnamen und Geburtsdatum anmelden.',
    'reg.waTitle': 'Wichtig: Bitte schreib uns jetzt eine WhatsApp.',
    'reg.waText': 'Unsere Dienstplanung läuft komplett über WhatsApp – Schichten, Änderungen und Rückfragen. Ohne WhatsApp-Kontakt können wir dich nicht einteilen. Tippe auf den Knopf, die Nachricht ist schon vorbereitet, du musst sie nur abschicken.',
    'reg.waButton': 'WhatsApp öffnen und Nachricht senden',
    'reg.waNote': 'Klappt der Knopf nicht: Nummer speichern und kurz „Hallo" schreiben an',
    'reg.errFirstname': 'Bitte geben Sie Ihren Vornamen ein',
    'reg.errLastname': 'Bitte geben Sie Ihren Nachnamen ein',
    'reg.errBirthdate': 'Bitte geben Sie Ihr Geburtsdatum ein (TT.MM.JJJJ)',
    'reg.errDateFormat': 'Ungültiges Datumsformat',
    'reg.errFailed': 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    // Dashboard Tabs
    'tab.overview': 'Übersicht',
    'tab.users': 'Mitarbeiter',
    'tab.personalPlanning': 'Schichtzuteilung',
    'tab.flexibleShifts': 'Bedarfsplanung',
    'tab.tasksAndPlanning': 'Aufgaben und Planung',
    'tab.availability': 'Verfügbarkeiten',
    'tab.documents': 'Dokumente',
    'tab.actualHours': 'Ist-Stunden',
    'tab.reports': 'Einsatz',
    'tab.luggageShipping': 'Gepäck-Versand',
    'tab.whatsappInbox': 'WhatsApp',
    'tab.wheelchairAdmin': 'Rollstuhl-\nVerleih',
    'tab.backups': 'Backups',

    // Dashboard Navigation
    'nav.brand': 'Oktoberfest Personalplanung',
    'nav.profile': 'Profil',
    'nav.logout': 'Abmelden',
    'nav.user': 'Benutzer',
    'nav.language': 'Sprache',

    // Dashboard Approval Wait
    'approval.title': 'Auf Freischaltung warten',
    'approval.description': 'Ihr Konto wurde erstellt, muss aber erst von einem Administrator freigeschaltet werden, bevor Sie den Rollstuhl-Admin nutzen können.',
    'approval.badge': 'Noch nicht freigeschaltet',

    // Overview
    'overview.title': 'Übersicht',
    'overview.welcome': 'Willkommen, {name}!',
    'overview.myShiftsToday': 'Meine Schichten heute ({date})',
    'overview.planningDraftTitle': '🚧 Dienstplan noch in Arbeit!',
    'overview.planningDraftText': 'Was du hier siehst, ist noch NICHT final – Zeiten können sich ändern und noch nicht alle Tage sind verplant. Also nicht wundern! Sobald dein Dienstplan final ist, bekommst du automatisch eine WhatsApp von uns. 📲',
    'overview.currentShifts': 'Aktuelle Schichten',
    'overview.loading': 'Lade...',
    'overview.loadingShifts': 'Lade deine heutigen Schichten...',
    'overview.time': 'Zeit',
    'overview.station': 'Station',
    'overview.status': 'Status',
    'overview.planned': 'Geplant',
    'overview.noShifts': 'Du hast heute keine geplanten Schichten.',
    'overview.freeDay': 'Genieße deinen freien Tag! 🎉',
    'overview.adminPlaceholder': 'Hier werden die aktuellen Schichten angezeigt...',
    'overview.notifications': 'Benachrichtigungen',
    'overview.noNotifications': 'Keine neuen Benachrichtigungen',

    // Weekdays
    'day.sunday': 'Sonntag',
    'day.monday': 'Montag',
    'day.tuesday': 'Dienstag',
    'day.wednesday': 'Mittwoch',
    'day.thursday': 'Donnerstag',
    'day.friday': 'Freitag',
    'day.saturday': 'Samstag',

    // Availability
    'avail.title': 'Mitarbeiter-Verfügbarkeiten',
    'avail.add': 'Verfügbarkeit hinzufügen',
    'avail.filter': 'Filter',
    'avail.allEmployees': 'Alle Mitarbeiter',
    'avail.onlyYours': 'Sie können nur Ihre eigenen Verfügbarkeiten verwalten',
    'avail.withoutAvail': 'Mitarbeiter ohne Verfügbarkeit',
    'avail.allHaveAvail': 'Alle haben Verfügbarkeit eingetragen',
    'avail.searchPlaceholder': 'Name suchen...',
    'avail.noMatch': 'Kein Treffer',
    'avail.selectEmployee': 'Mitarbeiter ohne Verfügbarkeit wählen...',
    'avail.showWithout': 'Zeigt nur Mitarbeiter ohne bereits eingetragene Verfügbarkeit',
    'avail.dateSpecific': 'Datum-spezifische Verfügbarkeit',
    'avail.fromDate': 'Von Datum',
    'avail.toDate': 'Bis Datum',
    'avail.available': 'Verfügbar',
    'avail.notAvailable': 'Nicht verfügbar',
    'avail.mixed': 'Gemischt',
    'avail.selected': 'Ausgewählt',
    'avail.noEntry': 'Keine Eingabe',
    'avail.weekday': 'Wochentag',
    'avail.notes': 'Notizen',
    'avail.actions': 'Aktionen',
    'avail.noData': 'Keine Verfügbarkeiten erfasst',
    'avail.pleaseEnter': 'Bitte Verfügbarkeit eintragen',
    'avail.flexible': 'Flexibel',
    'avail.morning': 'Morgens',
    'avail.midday': 'Mittags',
    'avail.evening': 'Abends',
    'avail.custom': 'Individuell',
    'avail.editModal': 'Verfügbarkeit bearbeiten',
    'avail.multiModal': 'Verfügbarkeiten für mehrere Tage',
    'avail.newModal': 'Neue Verfügbarkeit',
    'avail.multiDays': 'Mehrere Tage gleichzeitig',
    'avail.type': 'Verfügbarkeitstyp',
    'avail.savedMulti': 'Verfügbarkeiten für {count} Tage erfolgreich gespeichert!',
    'avail.savedPartial': '{count} Verfügbarkeiten gespeichert. Fehler: {errors}',
    'avail.saved': 'Verfügbarkeit erfolgreich gespeichert!',
    'avail.deleted': 'Verfügbarkeit erfolgreich gelöscht',
    'avail.confirmDelete': 'Verfügbarkeit wirklich löschen?',
    'avail.flexTime': '⏰ 07:00 - 01:00 (nächster Tag)',
    'avail.morningTime': '🌅 07:00 - 14:00',
    'avail.middayTime': '☀️ 11:00 - 18:00',
    'avail.eveningTime': '🌙 18:00 - 01:00 (nächster Tag)',
    'avail.customTime': '✏️ Eigene Zeiten eingeben',
    'avail.selectDate': 'Bitte wählen Sie mindestens ein Datum aus.',
    'avail.selectOneDate': 'Bitte wählen Sie ein Datum aus.',
    'avail.autoFlexible': 'Flexibel verfügbar (ganzer Tag)',
    'avail.autoMorning': 'Flexibel verfügbar (Morgens)',
    'avail.autoMidday': 'Flexibel verfügbar (Mittags)',
    'avail.autoEvening': 'Flexibel verfügbar (Abends)',
    'avail.save': 'Speichern',
    'avail.cancel': 'Abbrechen',
    'avail.delete': 'Löschen',
    'avail.hintFillAll': 'Bitte für jeden Tag wenn möglich was eintragen, auch wenn nicht verfügbar. Das hilft bei der Planung.',
    'avail.shortAvailWarning': 'Bei einer so kurzen Verfügbarkeit (3 Stunden oder weniger) wird ein tatsächlicher Einsatz unwahrscheinlicher.',
    'avail.hintOnlyAvail': 'Hier gibst du nur deine Verfügbarkeit an – deine tatsächliche Arbeitszeit wird aus diesem Zeitfenster geplant.',
    'avail.existingEntries': 'Vorhandene Einträge',
    'avail.replaceExisting': 'Bestehende Einträge ersetzen',
    'avail.replaceExistingHint': 'empfohlen – die alten Zeiten für diesen Tag werden gelöscht',
    'avail.addWindow': 'Zusätzliches Zeitfenster anlegen',
    'avail.addWindowHint': 'z. B. vormittags UND abends verfügbar, dazwischen nicht',
    'avail.newestEntry': 'zuletzt eingetragen',
    'avail.olderEntry': 'älterer Eintrag',
    'avail.fullDayFlex': 'Ganzer Tag (flexibel)',
    'avail.noteOptional': 'Notiz (optional)',
    'avail.alsoApplyTo': 'Auch anwenden auf:',
    'avail.deselect': 'Abwählen',
    'avail.additionalDays': '{count} weitere(r) Tag(e) ausgewählt',
    'avail.daysHaveEntries': '{count} der gewählten Tage haben bereits Einträge',
    'avail.willReplace': 'diese werden ersetzt',
    'avail.willAdd': 'das neue Zeitfenster kommt zusätzlich dazu',
    'avail.switchMode': 'umschalten',
    'avail.update': 'Aktualisieren',
    'avail.days': 'Tage',
    'avail.allDays': 'Alle',
    'avail.filterFirst': 'Bitte zuerst oben einen Mitarbeiter filtern.',
    'avail.calendarView': 'Kalender-Ansicht',
    'avail.clickDate': 'Klicken Sie direkt auf ein Datum, um die Verfügbarkeit zu bearbeiten',
    'avail.showingFor': 'Anzeige nur für:',
    'avail.withoutAvailFor': 'Ohne Verfügbarkeit:',
    'avail.adminFilterFirst': 'Bitte zuerst oben einen Mitarbeiter filtern, um Verfügbarkeiten einzutragen.',
    'avail.notePlaceholder': 'z.B. nur wenn nötig, Arzttermin ab 15 Uhr...',
    'avail.legendGreen': 'Grün',
    'avail.legendRed': 'Rot',
    'avail.legendYellow': 'Gelb',
    'avail.legendBlue': 'Blau',
    'avail.legendGray': 'Grau',
    'avail.progress': 'Fortschritt',
    'avail.statsAvail': 'verfügbar',
    'avail.statsNotAvail': 'nicht verfügbar',
    'avail.statsOpen': 'offen',

    // Partner
    'partner.title': 'Partner-Team',
    'partner.myCode': 'Mein Partnercode',
    'partner.copy': 'Code kopieren',
    'partner.regenerate': 'Neuen Code generieren',
    'partner.shareHint': 'Teile diesen Code mit Kollegen, mit denen du gerne arbeitest.',
    'partner.addByCode': 'Partner hinzufügen',
    'partner.link': 'Verknüpfen',
    'partner.linked': 'Partner erfolgreich verknüpft!',
    'partner.unlinked': 'Verknüpfung aufgehoben.',
    'partner.codeRegenerated': 'Neuer Partnercode generiert.',
    'partner.myPartners': 'Meine Partner',
    'partner.noPartners': 'Noch keine Partner verknüpft. Tausche deinen Code mit Kollegen!',
    'partner.noEntry': 'Kein Eintrag für diesen Tag',
    'partner.noAccess': 'Kein Zugriff',
    'partner.visibilityLabel': 'Meine Partner dürfen meine Arbeitszeit sehen',
    'partner.visibilityHint': 'Wenn aktiviert, können deine Partner deine Verfügbarkeit in der Übersicht sehen.',
    'partner.shareNumberLabel': 'Meine Partner dürfen meine Handynummer sehen',
    'partner.shareNumberHint': 'Wenn aktiviert, kann deine Handynummer mit verbundenen Partnern geteilt werden (z.B. zum Absprechen per WhatsApp).',
    'partner.visibilityOn': 'Sichtbarkeit aktiviert',
    'partner.visibilityOff': 'Sichtbarkeit deaktiviert',
    'partner.overview': 'Partner-Übersicht',
    'partner.overviewHint': 'Nur Partner mit aktivierter Sichtbarkeit werden angezeigt. Nur lesen.',
    'partner.refresh': 'Aktualisieren',

    // Documents
    'doc.title': 'Dokumentenverwaltung',
    'doc.upload': 'Dokument hochladen',
    'doc.employee': 'Mitarbeiter *',
    'doc.select': 'Wählen...',
    'doc.docType': 'Dokumenttyp',
    'doc.selectFile': 'Datei auswählen *',
    'doc.uploading': 'Upload...',
    'doc.uploadBtn': 'Hochladen',
    'doc.filterEmployee': 'Nach Mitarbeiter filtern',
    'doc.allEmployees': 'Alle Mitarbeiter',
    'doc.overview': 'Dokumenten-Übersicht',
    'doc.noDocuments': 'Keine Dokumente vorhanden',
    'doc.contractTemplate': 'Arbeitsvertrag Vorlage verwalten',
    'doc.tabDocuments': 'Dokumente',
    'doc.tabTemplate': 'Arbeitsvertrag Vorlage',
    'doc.tabSubmitted': 'Eingereichte Verträge',
    'doc.tabMyDocs': 'Meine Dokumente',
    'doc.tabMyContract': 'Mein Arbeitsvertrag',
    'doc.filename': 'Dateiname',
    'doc.type': 'Typ',
    'doc.status': 'Status',
    'doc.date': 'Datum',
    'doc.actions': 'Aktionen',
    'doc.view': 'Anzeigen',
    'doc.deleteBtn': 'Löschen',
    'doc.uploaded': 'Dokument erfolgreich hochgeladen!',
    'doc.deleted': 'Dokument erfolgreich gelöscht!',
    'doc.contractSubmitted': 'Arbeitsvertrag erfolgreich eingereicht!',
    'doc.contractDraft': 'Arbeitsvertrag als Entwurf gespeichert!',
    'doc.contractDeleted': 'Vertrag erfolgreich gelöscht!',
    'doc.selectEmployee': 'Bitte wählen Sie einen Mitarbeiter aus',
    'doc.confirmDelete': 'Dokument "{name}" wirklich löschen?',
    'doc.confirmContractDelete': 'Sind Sie sicher, dass Sie diesen Vertrag endgültig löschen möchten?',
    'doc.templateSaved': 'Vertragsvorlage erfolgreich gespeichert!',
    'doc.statusPending': 'Ausstehend',
    'doc.statusApproved': 'Genehmigt',
    'doc.statusRejected': 'Abgelehnt',
    'doc.typeContract': 'Arbeitsvertrag',
    'doc.typeAvailability': 'Verfügbarkeit',
    'doc.typePayslip': 'Lohnabrechnung',
    'doc.typeResidencePermit': 'Aufenthaltstitel',
    'doc.typeWorkPermit': 'Arbeitsgenehmigung',
    'doc.typeOther': 'Sonstiges',
    'doc.submittedContracts': 'Eingereichte Arbeitsverträge',
    'doc.submittedContractsDesc': 'Von Mitarbeitern eingereichte Verträge prüfen, genehmigen oder ablehnen',
    'doc.noContracts': 'Keine eingereichten Verträge vorhanden',
    'doc.submittedAt': 'Eingereicht am',
    'doc.signatures': 'Unterschriften',
    'doc.statusSubmitted': 'Eingereicht',
    'doc.statusDraft': 'Entwurf',
    'doc.noSignatures': 'Keine Unterschriften',
    'doc.contractTitle': 'Arbeitsvertrag',
    'doc.approve': 'Genehmigen',
    'doc.reject': 'Ablehnen',
    'doc.generatePdf': 'PDF generieren',
    'doc.close': 'Schließen',
    'doc.contractApproved': 'Vertrag genehmigt!',
    'doc.contractApprovedWithPdf': 'Vertrag genehmigt und PDF in den Dokumenten abgelegt!',
    'doc.contractApprovedWithDoc': 'Vertrag genehmigt und als Dokument abgelegt!',
    'doc.contractApprovedBut': 'Vertrag genehmigt, aber: {warning}',
    'doc.errorUpdateStatus': 'Fehler beim Aktualisieren des Vertragsstatus',
    'doc.contractNotFound': 'Vertrag nicht gefunden',
    'doc.pdfGenerating': 'PDF wird erstellt...',
    'doc.pdfCreated': 'PDF erfolgreich erstellt!',
    'doc.errorPdfCreation': 'Fehler beim Erstellen des PDFs',
    'doc.errorPdfGeneration': 'Fehler beim Generieren des PDFs',
    'doc.errorDeleteContract': 'Fehler beim Löschen des Vertrags',
    'doc.errorUpload': 'Fehler beim Hochladen',
    'doc.errorDelete': 'Fehler beim Löschen',
    'doc.unknownError': 'Unbekannter Fehler',
    'doc.errorDeleteDoc': 'Fehler beim Löschen des Dokuments',
    'doc.errorNoUserId': 'Keine Benutzer-ID gefunden – bitte neu anmelden',
    'doc.errorUnauthorized': 'Nicht angemeldet – bitte neu anmelden',
    'doc.errorForbidden': 'Keine Berechtigung für diese Aktion',
    'doc.errorViewDoc': 'Fehler beim Anzeigen des Dokuments',
    'doc.statusChanged': 'Status geändert: {status}',
    'doc.errorChangeStatus': 'Fehler beim Ändern des Status',
    'doc.manageTemplate': 'Arbeitsvertrag Vorlage verwalten',
    'doc.manageTemplateDesc': 'Vorlage bearbeiten, die Mitarbeiter beim Ausfüllen ihres Vertrags sehen',
    'doc.contractSubmittedOn': 'Vertrag eingereicht am',
    'doc.contractApprovedMsg': 'Ihr Vertrag wurde genehmigt.',
    'doc.contractRejectedMsg': 'Ihr Vertrag wurde abgelehnt. Bitte prüfen und erneut einreichen.',
    'doc.rejectionReason': 'Grund',

    // Employee Work Reports (Einsatz)
    'reports.title': 'Einsatzzeiten {year}',
    'reports.loading': 'Lädt...',
    'reports.loadingYear': 'Lade Einsatzzeiten für {year}...',
    'reports.selectYear': 'Jahr auswählen:',
    'reports.yearHint': 'Das ausgewählte Jahr wird für alle Einsatzzeiten und Stundenbestätigungen verwendet.',
    'reports.calendarError': '❌ Kalender-Export ist nur für geplante Schichten verfügbar.',
    'reports.noShiftsExport': '❌ Keine geplanten Schichten zum Exportieren vorhanden.',
    'reports.exported': '✅ Geplante Schichten exportiert!',
    'reports.cannotConfirm': '❌ Sie können Ihre tatsächlichen Stunden noch nicht bestätigen.',
    'reports.unknown': 'Unbekannt',
    'reports.kitchen': 'Küche',
    'reports.service': 'Service',
    'reports.bar': 'Bar',
    'reports.cashRegister': 'Kasse',
    'reports.unknownStation': 'Unbekannte Station',
    'reports.tabShifts': 'Geplante Schichten',
    'reports.tabTimes': 'Ist-Zeiten',
    'reports.hourConfirmation': 'Stundenbestätigung',
    'reports.exportCalendar': 'Kalender exportieren',

    // Wheelchair Admin
    'wc.title': '🦽 Rollstuhl-Verwaltung',
    'wc.refresh': 'Aktualisieren',
    'wc.retry': 'Erneut versuchen',
    'wc.totalBookings': 'Gesamt Buchungen',
    'wc.today': 'Heute',
    'wc.wheelchairs': 'Rollstühle',
    'wc.stations': 'Stationen',
    'wc.filter': 'Filter',
    'wc.fromDate': 'Von Datum',
    'wc.toDate': 'Bis Datum',
    'wc.resetFilter': 'Filter zurücksetzen',
    'wc.bookings': 'Buchungen ({count})',
    'wc.noBookings': 'Keine Buchungen gefunden',
    'wc.noBookingsDesc': 'Es gibt keine Buchungen für den ausgewählten Zeitraum.',
    'wc.id': 'ID',
    'wc.customer': 'Kunde',
    'wc.phone': 'Telefon',
    'wc.date': 'Datum',
    'wc.startTime': 'Startzeit',
    'wc.endTime': 'Endzeit',
    'wc.wheelchair': 'Rollstuhl',
    'wc.station': 'Station',
    'wc.remarks': 'Anmerkungen',
    'wc.actions': 'Aktionen',
    'wc.wheelchairNum': 'Rollstuhl {num}',
    'wc.phonePlaceholder': 'Telefonnummer',
    'wc.remarksPlaceholder': 'Anmerkungen...',
    'wc.save': 'Speichern',
    'wc.cancelEdit': 'Abbrechen',
    'wc.edit': 'Bearbeiten',
    'wc.delete': 'Löschen',
    'wc.confirmDelete': 'Sind Sie sicher, dass Sie diese Buchung löschen möchten?',
    'wc.loadingData': 'Lädt...',
    'wc.loadError': 'Fehler beim Laden der Daten',
    'wc.noBookingsForPeriod': 'Es gibt keine Buchungen für den ausgewählten Zeitraum.',

    // Wheelchair Rental (Public Landing Page)
    'wr.title': '🦽 Rollstuhlvermietung Oktoberfest {year}',
    'wr.hours': 'Öffnungszeiten während des Oktoberfests:',
    'wr.period': 'Verfügbarkeitszeitraum: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Tag auswählen',
    'wr.step2': '2. Uhrzeit auswählen',
    'wr.step3': '3. Station & Rollstuhl wählen',
    'wr.startTime': 'Startzeit:',
    'wr.selectStart': 'Startzeit wählen',
    'wr.endTime': 'Endzeit:',
    'wr.selectEnd': 'Endzeit wählen',
    'wr.name': 'Name (Pflichtfeld):',
    'wr.namePlaceholder': 'Ihr vollständiger Name',
    'wr.phoneLbl': 'Telefonnummer (optional):',
    'wr.emailLbl': 'E-Mail (optional):',
    'wr.phonePlaceholder': 'Ihre Telefonnummer',
    'wr.remarksLbl': 'Anmerkungen (optional):',
    'wr.remarksPlaceholder': 'Zusätzliche Anmerkungen zur Buchung',
    'wr.hour': '{h}:00 Uhr',
    'wr.endOfDay': '24:00 Uhr (Tagesende)',
    'wr.selectTimeInfo': 'Wählen Sie Start- und Endzeit für {date}',
    'wr.checkingAvail': 'Prüfe Verfügbarkeit...',
    'wr.selectedPeriod': 'Gewählter Zeitraum:',
    'wr.availableWheelchairs': 'Verfügbare Rollstühle ({count}):',
    'wr.wheelchairNum': 'Rollstuhl {num}',
    'wr.stationName': 'Station: {name}',
    'wr.bookNow': 'Jetzt buchen',
    'wr.booking': 'Buche...',
    'wr.map': '(Karte)',
    'wr.enterName': 'Bitte zuerst Namen eingeben',
    'wr.bookingSuccess': '✅ Buchung erfolgreich!',
    'wr.bookingError': 'Buchungsfehler',
    'wr.bookingSuccessMsg': 'Buchung erfolgreich für {date}!',
    'wr.newBooking': 'Neue Buchung',
    'wr.copyDetails': '📋 Details kopieren',
    'wr.copied': 'Buchungsdetails kopiert!',
    'wr.bookingNum': 'Buchungsnummer:',
    'wr.bookingName': 'Name:',
    'wr.bookingWheelchair': 'Rollstuhl:',
    'wr.bookingStation': 'Station:',
    'wr.bookingDate': 'Datum:',
    'wr.bookingTime': 'Zeit:',
    'wr.selectDateTime': 'Bitte wählen Sie Datum, Start- und Endzeit aus',
    'wr.endAfterStart': 'Die Endzeit muss nach der Startzeit liegen',
    'wr.enterNameAlert': 'Bitte geben Sie Ihren Namen ein',
    'wr.availError': 'Fehler bei der Verfügbarkeitsprüfung',
    'wr.bookingErrorMsg': 'Fehler bei der Buchung',
    'wr.noWheelchairs': 'Keine Rollstühle für diesen Zeitraum verfügbar.',
    'wr.chooseOtherTimes': 'Bitte wählen Sie andere Zeiten.',
    'wr.unknownStation': 'Unbekannte Station',
    'wr.clock': 'Uhr',
    'wr.backToLogin': 'Zurück zur Anmeldung',
    'day.sunShort': 'So', 'day.monShort': 'Mo', 'day.tueShort': 'Di',
    'day.wedShort': 'Mi', 'day.thuShort': 'Do', 'day.friShort': 'Fr', 'day.satShort': 'Sa',

    // Common
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.close': 'Schließen',
    'common.loading': 'Laden...',
    'common.error': 'Fehler',
    'common.success': 'Erfolg',
    'common.unknown': 'Unbekannt',

    // Contract Form
    'contract.title': 'Digitaler Arbeitsvertrag',
    'contract.templateTitle': 'Arbeitsvertrag - Vorlage bearbeiten',
    'contract.templateSubtitle': 'Admin-Vorlage für neue Verträge',
    'contract.formSubtitle': 'Vertrag zum Ausfüllen',
    'contract.loadTemplate': 'Meine Vorlage laden',
    'contract.saving': 'Speichert...',
    'contract.save': 'Speichern',
    'contract.cancel': 'Abbrechen',
    'contract.edit': 'Bearbeiten',
    'contract.editContract': 'Vertrag bearbeiten',
    'contract.fillContract': 'Vertrag ausfüllen',
    'contract.printPdf': 'Als PDF drucken',
    'contract.contractHeading': 'Vertrag über ein kurzfristiges Beschäftigungsverhältnis',
    'contract.between': 'Zwischen',
    'contract.employerLabel': '- nachfolgend „Arbeitgeber" genannt -',
    'contract.and': 'und',
    'contract.employeeLabel': 'Arbeitnehmer/in:',
    'contract.employeeFollowing': '- nachfolgend „Arbeitnehmer/-in" genannt - wird Folgendes geschlossen:',
    'contract.nameLabel': 'Name, Vorname:',
    'contract.step': 'Schritt',
    'contract.next': 'Weiter',
    'contract.back': 'Zurück',
    'contract.stepPersonal': 'Persönliche Daten',
    'contract.stepTax': 'Steuer & Bank',
    'contract.stepDocuments': 'Dokumente',
    'contract.wzStreet': 'Straße',
    'contract.wzHouseNr': 'Hausnummer',
    'contract.wzPlz': 'PLZ',
    'contract.wzCity': 'Ort',
    'contract.wzBirthdate': 'Geburtsdatum',
    'contract.wzBirthPlace': 'Geburtsort',
    'contract.wzNationality': 'Staatsangehörigkeit',
    'contract.wzTaxId': 'Steuer-Identifikationsnummer',
    'contract.wzAccountHolder': 'Kontoinhaber (falls abweichend)',
    'contract.wzSocialBenefits': 'Beziehst du Sozialleistungen?',
    'contract.wzPrevJobs': 'Kurzfristige Vorbeschäftigungen dieses Jahr',
    'contract.wzNoPrevJobs': 'Keine Vorbeschäftigungen',
    'contract.wzEmployer': 'Arbeitgeber',
    'contract.wzAddJob': 'Beschäftigung hinzufügen',
    'contract.wzIdCard': 'Personalausweis / Reisepass (Foto)',
    'contract.wzRemove': 'Entfernen',
    'contract.wzWorkPermit': 'Arbeitserlaubnis',
    'contract.wzResidence': 'Aufenthaltstitel',
    'contract.uploadResidence': 'Bitte lade den Aufenthaltstitel hoch.',
    'contract.wzWorkPermitHint': 'Für Staatsangehörige außerhalb der EU erforderlich.',
    'contract.wzWorkPermitHelpTitle': 'Wo finde ich meine Arbeitserlaubnis?',
    'contract.wzWorkPermitHelp': 'Schau auf deinen Aufenthaltstitel (Karte oder Zusatzblatt). Dort steht ein Satz wie „Erwerbstätigkeit erlaubt", „Erwerbstätigkeit gestattet" oder „Beschäftigung erlaubt" – genau das ist die Arbeitserlaubnis, ein extra Dokument gibt es nicht. Lade hier ein Foto der Seite hoch, auf der dieser Satz steht (meist Rückseite der Karte oder das Zusatzblatt), und darunter die Vorderseite deines Aufenthaltstitels. Steht dort „nicht erlaubt" oder „nur mit Erlaubnis der Ausländerbehörde", melde dich bitte bei uns.',
    'contract.parentSignRequired': 'Bei Minderjährigen ist die Unterschrift eines Erziehungsberechtigten erforderlich.',
    'contract.autoSaved': 'Automatisch gespeichert',
    'contract.namePlaceholder': 'Nachname, Vorname',
    'contract.toBeFilled': '[Wird ausgefüllt]',
    'contract.address': 'wohnhaft:',
    'contract.addressPlaceholder': '(Straße, Hausnummer, PLZ, Ort)',
    'contract.street': 'Straße',
    'contract.streetPlaceholder': 'Musterstraße',
    'contract.houseNr': 'Hausnr.',
    'contract.houseNrPlaceholder': '12a',
    'contract.plz': 'PLZ',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'Ort',
    'contract.cityPlaceholder': 'München',
    'contract.birthdate': 'Geburtsdatum:',
    'contract.nationality': 'Staatsangehörigkeit:',
    'contract.pleaseSelect': 'Bitte wählen...',
    'contract.workPermitRequired': 'Nachweis Arbeitsgenehmigung erforderlich',
    'contract.socialSecNr': 'Sozialversicherungsnummer:',
    'contract.socialSecPlaceholder': '__ __ __ __ __ __ __ __ __ __ __ (gem Sozialvers.Ausweis)',
    'contract.birthPlace': 'Geburtsort (Stadt/Ort):',
    'contract.birthPlacePlaceholder': 'Stadt/Ort',
    'contract.taxId': 'Steueridentifikationsnummer:',
    'contract.taxIdPlaceholder': 'Steuer-ID',
    'contract.socialBenefits': 'Sozialleistungen:',
    'contract.selectOption': 'Bitte eine Option auswählen',
    'contract.basicSecurity': 'Ich beziehe Grundsicherung',
    'contract.unemployment': 'Ich beziehe Arbeitslosengeld',
    'contract.pension': 'Ich beziehe Rente',
    'contract.noBenefits': 'Ich beziehe keins davon',
    'contract.receivesBasicSecurity': 'Bezieht Grundsicherung',
    'contract.receivesUnemployment': 'Bezieht Arbeitslosengeld',
    'contract.receivesPension': 'Bezieht Rente',
    'contract.receivesNone': 'Keine Grundsicherung, Arbeitslosengeld oder Rente',
    'contract.notFilled': '[Nicht ausgefüllt]',
    'contract.idCard': 'Personalausweis (Vorderseite)',
    'contract.idUploaded': 'Ausweis hochgeladen',
    'contract.remove': 'Entfernen',
    'contract.fileTooLarge': 'Die Datei ist zu groß. Maximal 10 MB erlaubt.',
    'contract.idUploadHelper': 'Bitte laden Sie ein Foto der Vorderseite Ihres Personalausweises hoch. (Pflichtfeld, max. 10 MB)',
    'contract.notUploaded': '[Nicht hochgeladen]',
    'contract.iban': 'IBAN:',
    'contract.ibanPlaceholder': 'DE__ ____ ____ ____ ____ __',
    'contract.altAccountHolder': 'Abweichender Kontoinhaber (falls zutreffend):',
    'contract.accountHolderPlaceholder': 'Name des Kontoinhabers',
    'contract.residencePermit': 'Aufenthaltstitel / Arbeitserlaubnis',
    'contract.nonEuNotice': 'Da Sie eine nicht-EU Staatsangehörigkeit angegeben haben, ist ein Nachweis der Arbeitserlaubnis bzw. des Aufenthaltstitels Pflicht.',
    'contract.docUploaded': 'Dokument hochgeladen',
    'contract.pdfUploaded': 'PDF-Dokument hochgeladen',
    'contract.workPermitUploadHelper': 'Bitte laden Sie ein Foto oder PDF Ihres Aufenthaltstitels/Arbeitserlaubnis hoch. (Pflichtfeld, max. 10 MB)',
    'contract.pdfExists': 'PDF-Dokument vorhanden',
    'contract.prevJobs': 'Angabe ausgeübte kurzfristige Beschäftigungen 2026',
    'contract.noPrevJobs': 'Keine kurzfristige Beschäftigung 2026 ausgeübt.',
    'contract.noPrevJobsCheck': 'keine kurzfristige Beschäftigung 2026 ausgeübt',
    'contract.from': 'Von:',
    'contract.to': 'Bis:',
    'contract.totalDays': 'Gesamttage:',
    'contract.employer': 'Arbeitgeber',
    'contract.actions': 'Aktionen',
    'contract.daysPlaceholder': 'Tage',
    'contract.companyPlaceholder': 'Firmenname',
    'contract.addJob': 'Weitere Beschäftigung hinzufügen',
    'contract.placeDate': 'Ort, Datum:',
    'contract.placePlaceholder': 'Ort eingeben *',
    'contract.placeDefault': '[Ort]',
    'contract.signedOn': 'Unterschrieben am:',
    'contract.notSigned': 'Noch nicht unterschrieben',
    'contract.employeeSignature': 'Unterschrift Arbeitnehmer/-in',
    'contract.signDigitally': 'Digital unterschreiben',
    'contract.uploadImage': 'Bild hochladen',
    'contract.deleteSignature': 'Löschen',
    'contract.employerSignatureNote': 'Unterschrift erfolgt durch Arbeitgeber',
    'contract.employerSignature': 'Unterschrift Arbeitgeber',
    'contract.minorRequired': 'Nur bei Minderjährigen erforderlich',
    'contract.parentSignature': 'Unterschrift Erziehungsberechtigter',
    'contract.parentNote': '(falls nicht volljährig)',
    'contract.adminInfo': 'Verwaltungsinformationen:',
    'contract.statusLabel': 'Status:',
    'contract.created': 'Erstellt:',
    'contract.modified': 'Geändert:',
    'contract.finalize': 'Vertrag abschließen',
    'contract.finalizeHint': 'Prüfen Sie alle Angaben und reichen Sie den Vertrag zur Bearbeitung ein.',
    'contract.templateOptions': 'Vorlage-Optionen',
    'contract.templateOptionsHint': 'Möchten Sie Ihre eingegebenen Daten als Vorlage für zukünftige Verträge speichern?',
    'contract.noTemplate': 'Nein, ohne Vorlage fortfahren',
    'contract.default': '(Standard)',
    'contract.yesTemplate': 'Ja, als Vorlage speichern (persönliche Daten werden gespeichert)',
    'contract.deleteTemplateOption': 'Bestehende Vorlage löschen',
    'contract.submitting': 'Wird eingereicht...',
    'contract.submit': 'Vertrag einreichen',
    'contract.back': 'Zurück',
    'contract.saveDraft': 'Als Entwurf speichern',
    'contract.myContracts': 'Meine Verträge',
    'contract.hide': 'Ausblenden',
    'contract.show': 'Anzeigen',
    'contract.loadingHistory': 'Lade Vertragshistorie...',
    'contract.noContracts': 'Noch keine Verträge erstellt',
    'contract.contractsHelperText': 'Ihre gespeicherten und eingereichten Verträge werden hier angezeigt.',
    'contract.createdAt': 'Erstellt am',
    'contract.position': 'Position',
    'contract.period': 'Zeitraum',
    'contract.submittedAt': 'Eingereicht',
    'contract.notSpecified': 'Nicht angegeben',
    'contract.statusSubmitted': 'Eingereicht',
    'contract.statusApproved': 'Genehmigt',
    'contract.statusRejected': 'Abgelehnt',
    'contract.statusDraft': 'Entwurf',
    'contract.totalContracts': 'Gesamt:',
    'contract.contractsSubmitted': 'eingereicht',
    'contract.contractsDrafts': 'Entwürfe',
    'contract.digitalSignature': 'Digitale Unterschrift',
    'contract.signatureEmployee': 'Arbeitnehmer',
    'contract.signatureParent': 'Erziehungsberechtigter',
    'contract.signatureHint': 'Unterschreiben Sie mit der Maus oder dem Finger im Bereich unten:',
    'contract.restart': 'Neu beginnen',
    'contract.acceptSignature': 'Unterschrift übernehmen',
    'contract.fillRequired': 'Bitte füllen Sie folgende Pflichtfelder aus:',
    'contract.uploadIdCard': 'Bitte laden Sie ein Foto der Vorderseite Ihres Personalausweises hoch.',
    'contract.selectSocialBenefits': 'Bitte wählen Sie eine Option bei Sozialleistungen aus.',
    'contract.uploadWorkPermit': 'Bitte laden Sie einen Nachweis Ihrer Arbeitserlaubnis bzw. Ihres Aufenthaltstitels hoch.',
    'contract.fillPrevJobs': 'Bitte geben Sie bei den bisherigen kurzfristigen Beschäftigungen entweder eine Beschäftigung ein oder haken Sie "keine kurzfristige Beschäftigung 2026 ausgeübt" an.',
    'contract.prevJobsIncomplete': 'Bitte fülle die kurzfristige Beschäftigung VOLLSTÄNDIG aus (Von, Bis, Gesamttage, Arbeitgeber) – oder entferne die Zeile bzw. hake "keine kurzfristige Beschäftigung" an.',
    'contract.signFirst': 'Bitte unterschreiben Sie den Vertrag vor der Einreichung.',
    'contract.signatureEmpty': 'Das Unterschriftsfeld ist leer. Bitte unterschreiben Sie zuerst im Feld.',
    'contract.saveError': 'Fehler beim Speichern des Vertrags',
    'contract.submitError': 'Fehler beim Einreichen des Vertrags',
    'contract.loadTemplateError': 'Fehler beim Laden der Vorlage',
    'contract.reqName': 'Name des Arbeitnehmers',
    'contract.reqAddress': 'Adresse des Arbeitnehmers',
    'contract.reqStreet': 'Straße',
    'contract.reqPLZ': 'PLZ',
    'contract.reqCity': 'Ort',
    'contract.reqBirthdate': 'Geburtsdatum',
    'contract.reqNationality': 'Staatsangehörigkeit',
    'contract.reqSocialSec': 'Sozialversicherungsnummer',
    'contract.reqBirthPlace': 'Geburtsort',
    'contract.reqTaxId': 'Steuer-ID',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Ort (vor der Unterschrift)',
    'contract.pdfLanguageNotice': 'Hinweis: Der Vertrag wird als PDF auf Deutsch erstellt.',
    'contract.pdfTranslationNotice': 'Hinweis: Der Vertrag wird als PDF auf Englisch erstellt.',
  },

  // ==================== ENGLISH ====================
  en: {
    'lug.title': 'Find your luggage',
    'lug.subtitle': 'Find your luggage',
    'lug.searchHint': 'Enter your ticket number to find the correct pickup station',
    'lug.ticketLabel': 'Ticket number',
    'lug.ticketPh': 'e.g. 1234 or 5678',
    'lug.ticketRange': 'Numbers from 1 to 12000',
    'lug.findStation': 'Find station',
    'lug.notFoundTitle': 'No station found',
    'lug.notFoundText': 'No baggage station could be matched to this ticket number. Please check the number.',
    'lug.pickupStation': 'Your pickup station',
    'lug.openMaps': 'Open Google Maps',
    'lug.cantPickup': "Can't pick up? Request shipping",
    'lug.shippingRequest': 'Shipping request',
    'lug.personalData': 'Personal information',
    'lug.fullName': 'Full name',
    'lug.emailLabel': 'Email',
    'lug.phoneLabel': 'Phone',
    'lug.address': 'Address',
    'lug.postalCode': 'Postal code',
    'lug.city': 'City',
    'lug.country': 'Country',
    'lug.requiredDocs': 'Required documents',
    'lug.ticketPhoto': 'Ticket photo',
    'lug.ticketPhotoHint': 'Photo or PDF of your ticket',
    'lug.dhlLabel': 'DHL shipping label',
    'lug.dhlBuyHint': 'You need to purchase a DHL label:',
    'lug.dhlBuy': 'Buy DHL label',
    'lug.dhlImportant': 'Important: Make sure to select the correct size and weight for your luggage!',
    'lug.send': 'Send shipping request',
    'lug.sending': 'Sending...',
    'lug.cancel': 'Cancel',
    'lug.successMsg': "Shipping request submitted successfully! You'll receive a confirmation email.",
    'lug.refLabel': 'Your reference number:',
    'lug.confirmMail': 'Confirmation will be sent to:',
    'lug.errRequired': 'Please fill in all required fields.',
    'lug.errSend': 'Error sending the request',
    'lug.back': 'Back to home',
    'reg.title': 'Application',
    'reg.subtitle': 'Oktoberfest Staff Planning',
    'reg.onlyTitle': 'Applicants only!',
    'reg.onlyText': 'This form is solely for applying as a staff member. For wheelchair service or luggage search, please use the links on the home page.',
    'reg.homepage': 'home page',
    'reg.firstname': 'First name',
    'reg.firstnamePh': 'Your first name',
    'reg.lastname': 'Last name',
    'reg.lastnamePh': 'Your last name',
    'reg.birthdate': 'Date of birth',
    'reg.birthdateHint': 'Also serves as your password for logging in',
    'reg.phone': 'Phone number',
    'reg.optional': '(optional)',
    'reg.email': 'Email',
    'reg.emailOptional': '(optional, for confirmation)',
    'reg.submit': 'Apply now',
    'reg.submitting': 'Registering...',
    'reg.alreadyReg': 'Already registered?',
    'reg.toLogin': 'Go to login',
    'reg.successTitle': 'Registration successful!',
    'reg.successText': 'Your account has been created. You can now log in with your last name and date of birth.',
    'reg.waTitle': 'Important: please send us a WhatsApp message now.',
    'reg.waText': 'Our shift planning runs entirely via WhatsApp – shifts, changes and questions. Without WhatsApp contact we cannot schedule you. Tap the button, the message is prepared, you only need to send it.',
    'reg.waButton': 'Open WhatsApp and send the message',
    'reg.waNote': 'If the button does not work: save the number and send a short "Hello" to',
    'reg.errFirstname': 'Please enter your first name',
    'reg.errLastname': 'Please enter your last name',
    'reg.errBirthdate': 'Please enter your date of birth (DD.MM.YYYY)',
    'reg.errDateFormat': 'Invalid date format',
    'reg.errFailed': 'Registration failed. Please try again.',
    'tab.overview': 'Overview',
    'tab.users': 'Employees',
    'tab.personalPlanning': 'Shift Assignment',
    'tab.flexibleShifts': 'Demand Planning',
    'tab.tasksAndPlanning': 'Tasks & Planning',
    'tab.availability': 'Availability',
    'tab.documents': 'Documents',
    'tab.actualHours': 'Actual Hours',
    'tab.reports': 'Shifts',
    'tab.luggageShipping': 'Luggage Shipping',
    'tab.whatsappInbox': 'WhatsApp',
    'tab.wheelchairAdmin': 'Wheelchair\nRental',
    'tab.backups': 'Backups',

    'nav.brand': 'Oktoberfest Staff Planning',
    'nav.profile': 'Profile',
    'nav.logout': 'Log out',
    'nav.user': 'User',
    'nav.language': 'Language',

    'approval.title': 'Waiting for activation',
    'approval.description': 'Your account has been created but must first be activated by an administrator before you can use the Wheelchair Admin.',
    'approval.badge': 'Not yet activated',

    'overview.title': 'Overview',
    'overview.welcome': 'Welcome, {name}!',
    'overview.myShiftsToday': 'My shifts today ({date})',
    'overview.planningDraftTitle': '🚧 Shift schedule still in progress!',
    'overview.planningDraftText': 'What you see here is NOT final yet – times may change and not all days are scheduled. So don\'t worry! As soon as your schedule is final, you will automatically get a WhatsApp from us. 📲',
    'overview.currentShifts': 'Current Shifts',
    'overview.loading': 'Loading...',
    'overview.loadingShifts': 'Loading your shifts for today...',
    'overview.time': 'Time',
    'overview.station': 'Station',
    'overview.status': 'Status',
    'overview.planned': 'Planned',
    'overview.noShifts': 'You have no scheduled shifts today.',
    'overview.freeDay': 'Enjoy your day off! 🎉',
    'overview.adminPlaceholder': 'Current shifts will be displayed here...',
    'overview.notifications': 'Notifications',
    'overview.noNotifications': 'No new notifications',

    'day.sunday': 'Sunday', 'day.monday': 'Monday', 'day.tuesday': 'Tuesday',
    'day.wednesday': 'Wednesday', 'day.thursday': 'Thursday', 'day.friday': 'Friday', 'day.saturday': 'Saturday',

    'avail.title': 'Employee Availability',
    'avail.add': 'Add Availability',
    'avail.filter': 'Filter',
    'avail.allEmployees': 'All Employees',
    'avail.onlyYours': 'You can only manage your own availability',
    'avail.withoutAvail': 'Employees without availability',
    'avail.allHaveAvail': 'Everyone has entered availability',
    'avail.searchPlaceholder': 'Search name...',
    'avail.noMatch': 'No match',
    'avail.selectEmployee': 'Select employee without availability...',
    'avail.showWithout': 'Shows only employees without existing availability entries',
    'avail.dateSpecific': 'Date-specific Availability',
    'avail.fromDate': 'From Date',
    'avail.toDate': 'To Date',
    'avail.available': 'Available',
    'avail.notAvailable': 'Not available',
    'avail.mixed': 'Mixed',
    'avail.selected': 'Selected',
    'avail.noEntry': 'No entry',
    'avail.weekday': 'Weekday',
    'avail.notes': 'Notes',
    'avail.actions': 'Actions',
    'avail.noData': 'No availability entries',
    'avail.pleaseEnter': 'Please enter availability',
    'avail.flexible': 'Flexible',
    'avail.morning': 'Morning',
    'avail.midday': 'Midday',
    'avail.evening': 'Evening',
    'avail.custom': 'Custom',
    'avail.editModal': 'Edit Availability',
    'avail.multiModal': 'Availability for multiple days',
    'avail.newModal': 'New Availability',
    'avail.multiDays': 'Multiple days at once',
    'avail.type': 'Availability type',
    'avail.savedMulti': 'Availability for {count} days saved successfully!',
    'avail.savedPartial': '{count} availabilities saved. Errors: {errors}',
    'avail.saved': 'Availability saved successfully!',
    'avail.deleted': 'Availability deleted successfully',
    'avail.confirmDelete': 'Really delete this availability?',
    'avail.flexTime': '⏰ 07:00 - 01:00 (next day)',
    'avail.morningTime': '🌅 07:00 - 14:00',
    'avail.middayTime': '☀️ 11:00 - 18:00',
    'avail.eveningTime': '🌙 18:00 - 01:00 (next day)',
    'avail.customTime': '✏️ Enter custom times',
    'avail.selectDate': 'Please select at least one date.',
    'avail.selectOneDate': 'Please select a date.',
    'avail.autoFlexible': 'Flexibly available (all day)',
    'avail.autoMorning': 'Flexibly available (morning)',
    'avail.autoMidday': 'Flexibly available (midday)',
    'avail.autoEvening': 'Flexibly available (evening)',
    'avail.save': 'Save',
    'avail.cancel': 'Cancel',
    'avail.delete': 'Delete',
    'avail.hintFillAll': 'Please enter something for each day if possible, even if not available. This helps with planning.',
    'avail.shortAvailWarning': 'With such a short availability (3 hours or less), an actual assignment becomes less likely.',
    'avail.hintOnlyAvail': 'Here you only indicate your availability – your actual working hours will be planned from this time window.',
    'avail.existingEntries': 'Existing entries',
    'avail.replaceExisting': 'Replace existing entries',
    'avail.replaceExistingHint': 'recommended – the old times for this day are removed',
    'avail.addWindow': 'Add another time window',
    'avail.addWindowHint': 'e.g. available in the morning AND evening, not in between',
    'avail.newestEntry': 'latest entry',
    'avail.olderEntry': 'older entry',
    'avail.fullDayFlex': 'Full day (flexible)',
    'avail.noteOptional': 'Note (optional)',
    'avail.alsoApplyTo': 'Also apply to:',
    'avail.deselect': 'Deselect',
    'avail.additionalDays': '{count} additional day(s) selected',
    'avail.daysHaveEntries': '{count} of the selected days already have entries',
    'avail.willReplace': 'they will be replaced',
    'avail.willAdd': 'the new time window is added on top',
    'avail.switchMode': 'switch',
    'avail.update': 'Update',
    'avail.days': 'days',
    'avail.allDays': 'All',
    'avail.filterFirst': 'Please filter an employee above first.',
    'avail.calendarView': 'Calendar view',
    'avail.clickDate': 'Click on a date to edit availability',
    'avail.showingFor': 'Showing for:',
    'avail.withoutAvailFor': 'Without availability:',
    'avail.adminFilterFirst': 'Please filter an employee above first to enter availabilities.',
    'avail.notePlaceholder': 'e.g. only if needed, doctor at 3pm...',
    'avail.legendGreen': 'Green',
    'avail.legendRed': 'Red',
    'avail.legendYellow': 'Yellow',
    'avail.legendBlue': 'Blue',
    'avail.legendGray': 'Gray',
    'avail.progress': 'Progress',
    'avail.statsAvail': 'available',
    'avail.statsNotAvail': 'not available',
    'avail.statsOpen': 'open',

    // Partner
    'partner.title': 'Partner Team',
    'partner.myCode': 'My Partner Code',
    'partner.copy': 'Copy code',
    'partner.regenerate': 'Generate new code',
    'partner.shareHint': 'Share this code with colleagues you\'d like to work with.',
    'partner.addByCode': 'Add Partner',
    'partner.link': 'Link',
    'partner.linked': 'Partner successfully linked!',
    'partner.unlinked': 'Link removed.',
    'partner.codeRegenerated': 'New partner code generated.',
    'partner.myPartners': 'My Partners',
    'partner.noPartners': 'No partners linked yet. Share your code with colleagues!',
    'partner.noEntry': 'No entry for this day',
    'partner.noAccess': 'No access',
    'partner.visibilityLabel': 'My partners may see my working hours',
    'partner.visibilityHint': 'When enabled, your partners can see your availability in the overview.',
    'partner.shareNumberLabel': 'My partners may see my phone number',
    'partner.shareNumberHint': 'When enabled, your phone number can be shared with linked partners (e.g. to coordinate via WhatsApp).',
    'partner.visibilityOn': 'Visibility enabled',
    'partner.visibilityOff': 'Visibility disabled',
    'partner.overview': 'Partner overview',
    'partner.overviewHint': 'Only partners with enabled visibility are shown. Read only.',
    'partner.refresh': 'Refresh',

    'doc.title': 'Document Management',
    'doc.upload': 'Upload Document',
    'doc.employee': 'Employee *',
    'doc.select': 'Select...',
    'doc.docType': 'Document Type',
    'doc.selectFile': 'Select File *',
    'doc.uploading': 'Uploading...',
    'doc.uploadBtn': 'Upload',
    'doc.filterEmployee': 'Filter by employee',
    'doc.allEmployees': 'All Employees',
    'doc.overview': 'Document Overview',
    'doc.noDocuments': 'No documents available',
    'doc.contractTemplate': 'Manage Employment Contract Template',
    'doc.tabDocuments': 'Documents',
    'doc.tabTemplate': 'Contract Template',
    'doc.tabSubmitted': 'Submitted Contracts',
    'doc.tabMyDocs': 'My Documents',
    'doc.tabMyContract': 'My Employment Contract',
    'doc.filename': 'Filename',
    'doc.type': 'Type',
    'doc.status': 'Status',
    'doc.date': 'Date',
    'doc.actions': 'Actions',
    'doc.view': 'View',
    'doc.deleteBtn': 'Delete',
    'doc.uploaded': 'Document uploaded successfully!',
    'doc.deleted': 'Document deleted successfully!',
    'doc.contractSubmitted': 'Employment contract submitted successfully!',
    'doc.contractDraft': 'Employment contract saved as draft!',
    'doc.contractDeleted': 'Contract deleted successfully!',
    'doc.selectEmployee': 'Please select an employee',
    'doc.confirmDelete': 'Really delete document "{name}"?',
    'doc.confirmContractDelete': 'Are you sure you want to permanently delete this contract?',
    'doc.templateSaved': 'Contract template saved successfully!',
    'doc.statusPending': 'Pending',
    'doc.statusApproved': 'Approved',
    'doc.statusRejected': 'Rejected',
    'doc.typeContract': 'Employment Contract',
    'doc.typeAvailability': 'Availability',
    'doc.typePayslip': 'Payslip',
    'doc.typeResidencePermit': 'Residence Permit',
    'doc.typeWorkPermit': 'Work Permit',
    'doc.typeOther': 'Other',
    'doc.submittedContracts': 'Submitted Employment Contracts',
    'doc.submittedContractsDesc': 'Review, approve or reject contracts submitted by employees',
    'doc.noContracts': 'No submitted contracts',
    'doc.submittedAt': 'Submitted at',
    'doc.signatures': 'Signatures',
    'doc.statusSubmitted': 'Submitted',
    'doc.statusDraft': 'Draft',
    'doc.noSignatures': 'No signatures',
    'doc.contractTitle': 'Employment Contract',
    'doc.approve': 'Approve',
    'doc.reject': 'Reject',
    'doc.generatePdf': 'Generate PDF',
    'doc.close': 'Close',
    'doc.contractApproved': 'Contract approved!',
    'doc.contractApprovedWithPdf': 'Contract approved and PDF stored in documents!',
    'doc.contractApprovedWithDoc': 'Contract approved and stored as document!',
    'doc.contractApprovedBut': 'Contract approved, but: {warning}',
    'doc.errorUpdateStatus': 'Error updating contract status',
    'doc.contractNotFound': 'Contract not found',
    'doc.pdfGenerating': 'Generating PDF...',
    'doc.pdfCreated': 'PDF created successfully!',
    'doc.errorPdfCreation': 'Error creating PDF',
    'doc.errorPdfGeneration': 'Error generating PDF',
    'doc.errorDeleteContract': 'Error deleting contract',
    'doc.errorUpload': 'Upload error',
    'doc.errorDelete': 'Error deleting',
    'doc.unknownError': 'Unknown error',
    'doc.errorDeleteDoc': 'Error deleting document',
    'doc.errorNoUserId': 'No user ID found – please log in again',
    'doc.errorUnauthorized': 'Not logged in – please log in again',
    'doc.errorForbidden': 'No permission for this action',
    'doc.errorViewDoc': 'Error displaying document',
    'doc.statusChanged': 'Status changed: {status}',
    'doc.errorChangeStatus': 'Error changing status',
    'doc.manageTemplate': 'Manage employment contract template',
    'doc.manageTemplateDesc': 'Edit the template employees see when filling in their contract',
    'doc.contractSubmittedOn': 'Contract submitted on',
    'doc.contractApprovedMsg': 'Your contract has been approved.',
    'doc.contractRejectedMsg': 'Your contract was rejected. Please review and resubmit.',
    'doc.rejectionReason': 'Reason',

    'reports.title': 'Shift Times {year}',
    'reports.loading': 'Loading...',
    'reports.loadingYear': 'Loading shift times for {year}...',
    'reports.selectYear': 'Select year:',
    'reports.yearHint': 'The selected year is used for all shift times and hour confirmations.',
    'reports.calendarError': '❌ Calendar export is only available for planned shifts.',
    'reports.noShiftsExport': '❌ No planned shifts to export.',
    'reports.exported': '✅ Planned shifts exported!',
    'reports.cannotConfirm': '❌ You cannot confirm your actual hours yet.',
    'reports.unknown': 'Unknown',
    'reports.kitchen': 'Kitchen',
    'reports.service': 'Service',
    'reports.bar': 'Bar',
    'reports.cashRegister': 'Cash Register',
    'reports.unknownStation': 'Unknown Station',
    'reports.tabShifts': 'Planned Shifts',
    'reports.tabTimes': 'Actual Times',
    'reports.hourConfirmation': 'Hour Confirmation',
    'reports.exportCalendar': 'Export Calendar',

    'wc.title': '🦽 Wheelchair Management',
    'wc.refresh': 'Refresh',
    'wc.retry': 'Try again',
    'wc.totalBookings': 'Total Bookings',
    'wc.today': 'Today',
    'wc.wheelchairs': 'Wheelchairs',
    'wc.stations': 'Stations',
    'wc.filter': 'Filter',
    'wc.fromDate': 'From Date',
    'wc.toDate': 'To Date',
    'wc.resetFilter': 'Reset Filter',
    'wc.bookings': 'Bookings ({count})',
    'wc.noBookings': 'No bookings found',
    'wc.noBookingsDesc': 'There are no bookings for the selected period.',
    'wc.id': 'ID', 'wc.customer': 'Customer', 'wc.phone': 'Phone',
    'wc.date': 'Date', 'wc.startTime': 'Start Time', 'wc.endTime': 'End Time',
    'wc.wheelchair': 'Wheelchair', 'wc.station': 'Station',
    'wc.remarks': 'Remarks', 'wc.actions': 'Actions',
    'wc.wheelchairNum': 'Wheelchair {num}',
    'wc.phonePlaceholder': 'Phone number',
    'wc.remarksPlaceholder': 'Remarks...',
    'wc.save': 'Save', 'wc.cancelEdit': 'Cancel', 'wc.edit': 'Edit', 'wc.delete': 'Delete',
    'wc.confirmDelete': 'Are you sure you want to delete this booking?',
    'wc.loadingData': 'Loading...', 'wc.loadError': 'Error loading data',
    'wc.noBookingsForPeriod': 'No bookings found for the selected period.',

    'wr.title': '🦽 Wheelchair Rental Oktoberfest {year}',
    'wr.hours': 'Opening hours during Oktoberfest:',
    'wr.period': 'Availability period: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Select a day',
    'wr.step2': '2. Select time',
    'wr.step3': '3. Choose station & wheelchair',
    'wr.startTime': 'Start time:',
    'wr.selectStart': 'Select start time',
    'wr.endTime': 'End time:',
    'wr.selectEnd': 'Select end time',
    'wr.name': 'Name (required):',
    'wr.namePlaceholder': 'Your full name',
    'wr.emailLbl': 'Email (optional):',
    'wr.phoneLbl': 'Phone number (optional):',
    'wr.phonePlaceholder': 'Your phone number',
    'wr.remarksLbl': 'Remarks (optional):',
    'wr.remarksPlaceholder': 'Additional remarks for the booking',
    'wr.hour': '{h}:00',
    'wr.endOfDay': '24:00 (end of day)',
    'wr.selectTimeInfo': 'Select start and end time for {date}',
    'wr.checkingAvail': 'Checking availability...',
    'wr.selectedPeriod': 'Selected period:',
    'wr.availableWheelchairs': 'Available wheelchairs ({count}):',
    'wr.wheelchairNum': 'Wheelchair {num}',
    'wr.stationName': 'Station: {name}',
    'wr.bookNow': 'Book now',
    'wr.booking': 'Booking...',
    'wr.map': '(Map)',
    'wr.enterName': 'Please enter your name first',
    'wr.bookingSuccess': '✅ Booking successful!',
    'wr.bookingError': 'Booking Error',
    'wr.bookingSuccessMsg': 'Booking successful for {date}!',
    'wr.newBooking': 'New Booking',
    'wr.copyDetails': '📋 Copy details',
    'wr.copied': 'Booking details copied!',
    'wr.bookingNum': 'Booking number:',
    'wr.bookingName': 'Name:',
    'wr.bookingWheelchair': 'Wheelchair:',
    'wr.bookingStation': 'Station:',
    'wr.bookingDate': 'Date:',
    'wr.bookingTime': 'Time:',
    'wr.selectDateTime': 'Please select date, start and end time',
    'wr.endAfterStart': 'End time must be after start time',
    'wr.enterNameAlert': 'Please enter your name',
    'wr.availError': 'Error checking availability',
    'wr.bookingErrorMsg': 'Error during booking',
    'wr.noWheelchairs': 'No wheelchairs available for this period.',
    'wr.chooseOtherTimes': 'Please choose different times.',
    'wr.unknownStation': 'Unknown station',
    'wr.clock': '',
    'wr.backToLogin': 'Back to login',
    'day.sunShort': 'Sun', 'day.monShort': 'Mon', 'day.tueShort': 'Tue',
    'day.wedShort': 'Wed', 'day.thuShort': 'Thu', 'day.friShort': 'Fri', 'day.satShort': 'Sat',

    'common.save': 'Save', 'common.cancel': 'Cancel', 'common.delete': 'Delete',
    'common.edit': 'Edit', 'common.close': 'Close', 'common.loading': 'Loading...',
    'common.error': 'Error', 'common.success': 'Success', 'common.unknown': 'Unknown',

    // Contract Form
    'contract.title': 'Digital Employment Contract',
    'contract.templateTitle': 'Employment Contract - Edit Template',
    'contract.templateSubtitle': 'Admin template for new contracts',
    'contract.formSubtitle': 'Contract to fill out',
    'contract.loadTemplate': 'Load my template',
    'contract.saving': 'Saving...',
    'contract.save': 'Save',
    'contract.cancel': 'Cancel',
    'contract.edit': 'Edit',
    'contract.editContract': 'Edit contract',
    'contract.fillContract': 'Fill out contract',
    'contract.printPdf': 'Print as PDF',
    'contract.contractHeading': 'Short-term Employment Contract',
    'contract.between': 'Between',
    'contract.employerLabel': '- hereinafter referred to as "Employer" -',
    'contract.and': 'and',
    'contract.employeeLabel': 'Employee:',
    'contract.employeeFollowing': '- hereinafter referred to as "Employee" - the following is agreed:',
    'contract.nameLabel': 'Last name, First name:',
    'contract.step': 'Step',
    'contract.next': 'Next',
    'contract.back': 'Back',
    'contract.stepPersonal': 'Personal data',
    'contract.stepTax': 'Tax & bank',
    'contract.stepDocuments': 'Documents',
    'contract.wzStreet': 'Street',
    'contract.wzHouseNr': 'House number',
    'contract.wzPlz': 'Postal code',
    'contract.wzCity': 'City',
    'contract.wzBirthdate': 'Date of birth',
    'contract.wzBirthPlace': 'Place of birth',
    'contract.wzNationality': 'Nationality',
    'contract.wzTaxId': 'Tax ID',
    'contract.wzAccountHolder': 'Account holder (if different)',
    'contract.wzSocialBenefits': 'Do you receive social benefits?',
    'contract.wzPrevJobs': 'Short-term prior jobs this year',
    'contract.wzNoPrevJobs': 'No prior jobs',
    'contract.wzEmployer': 'Employer',
    'contract.wzAddJob': 'Add job',
    'contract.wzIdCard': 'ID card / passport (photo)',
    'contract.wzRemove': 'Remove',
    'contract.wzWorkPermit': 'Work permit',
    'contract.wzResidence': 'Residence title',
    'contract.uploadResidence': 'Please upload the residence title.',
    'contract.wzWorkPermitHint': 'Required for non-EU nationals.',
    'contract.wzWorkPermitHelpTitle': 'Where do I find my work permit?',
    'contract.wzWorkPermitHelp': 'Look at your residence title (the card or its supplementary sheet). It contains a line such as "Erwerbstätigkeit erlaubt", "Erwerbstätigkeit gestattet" or "Beschäftigung erlaubt" (employment permitted) – that line IS your work permit; there is no separate document. Upload a photo of the side that shows this line (usually the back of the card or the supplementary sheet), and below it the front of your residence title. If it says "nicht erlaubt" (not permitted) or "nur mit Erlaubnis der Ausländerbehörde", please contact us.',
    'contract.parentSignRequired': 'For minors, a parent/guardian signature is required.',
    'contract.autoSaved': 'Saved automatically',
    'contract.namePlaceholder': 'Last name, First name',
    'contract.toBeFilled': '[To be filled]',
    'contract.address': 'residing at:',
    'contract.addressPlaceholder': '(Street, Number, Postal Code, City)',
    'contract.street': 'Street',
    'contract.streetPlaceholder': 'Main Street',
    'contract.houseNr': 'No.',
    'contract.houseNrPlaceholder': '12a',
    'contract.plz': 'Postal Code',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'City',
    'contract.cityPlaceholder': 'Munich',
    'contract.birthdate': 'Date of birth:',
    'contract.nationality': 'Nationality:',
    'contract.pleaseSelect': 'Please select...',
    'contract.workPermitRequired': 'Work permit proof required',
    'contract.socialSecNr': 'Social security number:',
    'contract.socialSecPlaceholder': '__ __ __ __ __ __ __ __ __ __ __ (as per social security card)',
    'contract.birthPlace': 'Place of birth (City):',
    'contract.birthPlacePlaceholder': 'City',
    'contract.taxId': 'Tax identification number:',
    'contract.taxIdPlaceholder': 'Tax ID',
    'contract.socialBenefits': 'Social benefits:',
    'contract.selectOption': 'Please select an option',
    'contract.basicSecurity': 'I receive basic security',
    'contract.unemployment': 'I receive unemployment benefits',
    'contract.pension': 'I receive a pension',
    'contract.noBenefits': 'I receive none of the above',
    'contract.receivesBasicSecurity': 'Receives basic security',
    'contract.receivesUnemployment': 'Receives unemployment benefits',
    'contract.receivesPension': 'Receives pension',
    'contract.receivesNone': 'No basic security, unemployment benefits or pension',
    'contract.notFilled': '[Not filled]',
    'contract.idCard': 'ID Card (front side)',
    'contract.idUploaded': 'ID uploaded',
    'contract.remove': 'Remove',
    'contract.fileTooLarge': 'File is too large. Maximum 10 MB allowed.',
    'contract.idUploadHelper': 'Please upload a photo of the front of your ID card. (Required, max. 10 MB)',
    'contract.notUploaded': '[Not uploaded]',
    'contract.iban': 'IBAN:',
    'contract.ibanPlaceholder': 'DE__ ____ ____ ____ ____ __',
    'contract.altAccountHolder': 'Alternative account holder (if applicable):',
    'contract.accountHolderPlaceholder': 'Account holder name',
    'contract.residencePermit': 'Residence permit / Work permit',
    'contract.nonEuNotice': 'Since you have specified a non-EU nationality, proof of work permit or residence title is required.',
    'contract.docUploaded': 'Document uploaded',
    'contract.pdfUploaded': 'PDF document uploaded',
    'contract.workPermitUploadHelper': 'Please upload a photo or PDF of your residence permit/work authorization. (Required, max. 10 MB)',
    'contract.pdfExists': 'PDF document available',
    'contract.prevJobs': 'Previous short-term employments in 2026',
    'contract.noPrevJobs': 'No short-term employment in 2026.',
    'contract.noPrevJobsCheck': 'no short-term employment in 2026',
    'contract.from': 'From:',
    'contract.to': 'To:',
    'contract.totalDays': 'Total days:',
    'contract.employer': 'Employer',
    'contract.actions': 'Actions',
    'contract.daysPlaceholder': 'Days',
    'contract.companyPlaceholder': 'Company name',
    'contract.addJob': 'Add another employment',
    'contract.placeDate': 'Place, Date:',
    'contract.placePlaceholder': 'Enter place *',
    'contract.placeDefault': '[Place]',
    'contract.signedOn': 'Signed on:',
    'contract.notSigned': 'Not yet signed',
    'contract.employeeSignature': 'Employee signature',
    'contract.signDigitally': 'Sign digitally',
    'contract.uploadImage': 'Upload image',
    'contract.deleteSignature': 'Delete',
    'contract.employerSignatureNote': 'Signature by employer',
    'contract.employerSignature': 'Employer signature',
    'contract.minorRequired': 'Only required for minors',
    'contract.parentSignature': 'Guardian signature',
    'contract.parentNote': '(if not of legal age)',
    'contract.adminInfo': 'Administration information:',
    'contract.statusLabel': 'Status:',
    'contract.created': 'Created:',
    'contract.modified': 'Modified:',
    'contract.finalize': 'Finalize contract',
    'contract.finalizeHint': 'Please review all information and submit the contract for processing.',
    'contract.templateOptions': 'Template options',
    'contract.templateOptionsHint': 'Would you like to save your data as a template for future contracts?',
    'contract.noTemplate': 'No, continue without template',
    'contract.default': '(Default)',
    'contract.yesTemplate': 'Yes, save as template (personal data will be saved)',
    'contract.deleteTemplateOption': 'Delete existing template',
    'contract.submitting': 'Submitting...',
    'contract.submit': 'Submit contract',
    'contract.back': 'Back',
    'contract.saveDraft': 'Save as draft',
    'contract.myContracts': 'My Contracts',
    'contract.hide': 'Hide',
    'contract.show': 'Show',
    'contract.loadingHistory': 'Loading contract history...',
    'contract.noContracts': 'No contracts created yet',
    'contract.contractsHelperText': 'Your saved and submitted contracts will be shown here.',
    'contract.createdAt': 'Created on',
    'contract.position': 'Position',
    'contract.period': 'Period',
    'contract.submittedAt': 'Submitted',
    'contract.notSpecified': 'Not specified',
    'contract.statusSubmitted': 'Submitted',
    'contract.statusApproved': 'Approved',
    'contract.statusRejected': 'Rejected',
    'contract.statusDraft': 'Draft',
    'contract.totalContracts': 'Total:',
    'contract.contractsSubmitted': 'submitted',
    'contract.contractsDrafts': 'drafts',
    'contract.digitalSignature': 'Digital Signature',
    'contract.signatureEmployee': 'Employee',
    'contract.signatureParent': 'Guardian',
    'contract.signatureHint': 'Sign with your mouse or finger in the area below:',
    'contract.restart': 'Start over',
    'contract.acceptSignature': 'Accept signature',
    'contract.fillRequired': 'Please fill in the following required fields:',
    'contract.uploadIdCard': 'Please upload a photo of the front of your ID card.',
    'contract.selectSocialBenefits': 'Please select an option for social benefits.',
    'contract.uploadWorkPermit': 'Please upload proof of your work permit or residence title.',
    'contract.fillPrevJobs': 'Please either enter a previous employment or check "no short-term employment in 2026".',
    'contract.prevJobsIncomplete': 'Please fill in the short-term employment COMPLETELY (from, to, total days, employer) – or remove the row / check "no short-term employment".',
    'contract.signFirst': 'Please sign the contract before submitting.',
    'contract.signatureEmpty': 'The signature field is empty. Please sign in the field first.',
    'contract.saveError': 'Error saving the contract',
    'contract.submitError': 'Error submitting the contract',
    'contract.loadTemplateError': 'Error loading the template',
    'contract.reqName': 'Employee name',
    'contract.reqAddress': 'Employee address',
    'contract.reqStreet': 'Street',
    'contract.reqPLZ': 'Postal code',
    'contract.reqCity': 'City',
    'contract.reqBirthdate': 'Date of birth',
    'contract.reqNationality': 'Nationality',
    'contract.reqSocialSec': 'Social security number',
    'contract.reqBirthPlace': 'Place of birth',
    'contract.reqTaxId': 'Tax ID',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Place (before signature)',
    'contract.pdfLanguageNotice': 'Note: The contract PDF will be generated in German.',
    'contract.pdfTranslationNotice': 'Note: The contract PDF will be generated in English.',
  },

  // ==================== TÜRKÇE ====================
  tr: {
    'lug.title': 'Bagajınızı bulun',
    'lug.subtitle': 'Bagajınızı bulun',
    'lug.searchHint': 'Doğru teslim alma istasyonunu bulmak için bilet numaranızı girin',
    'lug.ticketLabel': 'Bilet numarası',
    'lug.ticketPh': 'örn. 1234 veya 5678',
    'lug.ticketRange': '1 ile 12000 arası numaralar',
    'lug.findStation': 'İstasyon bul',
    'lug.notFoundTitle': 'İstasyon bulunamadı',
    'lug.notFoundText': 'Bu bilet numarasına bir bagaj istasyonu eşleştirilemedi. Lütfen numarayı kontrol edin.',
    'lug.pickupStation': 'Teslim alma istasyonunuz',
    'lug.openMaps': "Google Maps'i aç",
    'lug.cantPickup': 'Alamıyor musunuz? Gönderim talep edin',
    'lug.shippingRequest': 'Gönderim talebi',
    'lug.personalData': 'Kişisel bilgiler',
    'lug.fullName': 'Ad Soyad',
    'lug.emailLabel': 'E-posta',
    'lug.phoneLabel': 'Telefon',
    'lug.address': 'Adres',
    'lug.postalCode': 'Posta kodu',
    'lug.city': 'Şehir',
    'lug.country': 'Ülke',
    'lug.requiredDocs': 'Gerekli belgeler',
    'lug.ticketPhoto': 'Bilet fotoğrafı',
    'lug.ticketPhotoHint': 'Biletinizin fotoğrafı veya PDF’si',
    'lug.dhlLabel': 'DHL gönderi etiketi',
    'lug.dhlBuyHint': 'Bir DHL etiketi satın almanız gerekir:',
    'lug.dhlBuy': 'DHL etiketi satın al',
    'lug.dhlImportant': 'Önemli: Bagajınız için doğru boyut ve ağırlığı seçtiğinizden emin olun!',
    'lug.send': 'Gönderim talebini gönder',
    'lug.sending': 'Gönderiliyor...',
    'lug.cancel': 'İptal',
    'lug.successMsg': 'Gönderim talebi başarıyla iletildi! Bir onay e-postası alacaksınız.',
    'lug.refLabel': 'Referans numaranız:',
    'lug.confirmMail': 'Onay şu adrese gönderilir:',
    'lug.errRequired': 'Lütfen tüm zorunlu alanları doldurun.',
    'lug.errSend': 'Talep gönderilirken hata',
    'lug.back': 'Ana sayfaya dön',
    'reg.title': 'Başvuru',
    'reg.subtitle': 'Oktoberfest Personel Planlaması',
    'reg.onlyTitle': 'Sadece başvuru sahipleri için!',
    'reg.onlyText': 'Bu form yalnızca personel olarak başvuru içindir. Tekerlekli sandalye hizmeti veya bagaj arama için lütfen ana sayfadaki bağlantıları kullanın.',
    'reg.homepage': 'ana sayfa',
    'reg.firstname': 'Ad',
    'reg.firstnamePh': 'Adınız',
    'reg.lastname': 'Soyad',
    'reg.lastnamePh': 'Soyadınız',
    'reg.birthdate': 'Doğum tarihi',
    'reg.birthdateHint': 'Aynı zamanda giriş şifreniz olarak kullanılır',
    'reg.phone': 'Telefon numarası',
    'reg.optional': '(isteğe bağlı)',
    'reg.email': 'E-posta',
    'reg.emailOptional': '(isteğe bağlı, onay için)',
    'reg.submit': 'Şimdi başvur',
    'reg.submitting': 'Kaydediliyor...',
    'reg.alreadyReg': 'Zaten kayıtlı mısınız?',
    'reg.toLogin': 'Girişe git',
    'reg.successTitle': 'Kayıt başarılı!',
    'reg.successText': 'Hesabınız oluşturuldu. Artık soyadınız ve doğum tarihinizle giriş yapabilirsiniz.',
    'reg.errFirstname': 'Lütfen adınızı girin',
    'reg.errLastname': 'Lütfen soyadınızı girin',
    'reg.errBirthdate': 'Lütfen doğum tarihinizi girin (GG.AA.YYYY)',
    'reg.errDateFormat': 'Geçersiz tarih formatı',
    'reg.errFailed': 'Kayıt başarısız oldu. Lütfen tekrar deneyin.',
    'tab.overview': 'Genel Bakış',
    'tab.users': 'Çalışanlar',
    'tab.personalPlanning': 'Vardiya Atama',
    'tab.flexibleShifts': 'İhtiyaç Planlaması',
    'tab.tasksAndPlanning': 'Görevler ve Planlama',
    'tab.availability': 'Müsaitlik',
    'tab.documents': 'Belgeler',
    'tab.actualHours': 'Gerçek Saatler',
    'tab.reports': 'Vardiyalar',
    'tab.luggageShipping': 'Bagaj Gönderimi',
    'tab.wheelchairAdmin': 'Tekerlekli\nSandalye',
    'tab.backups': 'Yedeklemeler',

    'nav.brand': 'Oktoberfest Personel Planlaması',
    'nav.profile': 'Profil',
    'nav.logout': 'Çıkış yap',
    'nav.user': 'Kullanıcı',
    'nav.language': 'Dil',

    'approval.title': 'Aktivasyon bekleniyor',
    'approval.description': 'Hesabınız oluşturuldu ancak Tekerlekli Sandalye Yönetimini kullanabilmeniz için önce bir yönetici tarafından etkinleştirilmelidir.',
    'approval.badge': 'Henüz etkinleştirilmedi',

    'overview.title': 'Genel Bakış',
    'overview.welcome': 'Hoş geldiniz, {name}!',
    'overview.myShiftsToday': 'Bugünkü vardiyalarım ({date})',
    'overview.planningDraftTitle': '🚧 Vardiya planı hazırlanıyor!',
    'overview.planningDraftText': 'Burada gördükleriniz henüz KESİN değil – saatler değişebilir ve tüm günler henüz planlanmadı. Merak etmeyin! Planınız kesinleştiğinde otomatik olarak WhatsApp mesajı alacaksınız. 📲',
    'overview.currentShifts': 'Güncel Vardiyalar',
    'overview.loading': 'Yükleniyor...',
    'overview.loadingShifts': 'Bugünkü vardiyalarınız yükleniyor...',
    'overview.time': 'Zaman',
    'overview.station': 'İstasyon',
    'overview.status': 'Durum',
    'overview.planned': 'Planlandı',
    'overview.noShifts': 'Bugün planlanmış vardiyalarınız yok.',
    'overview.freeDay': 'İzin gününüzün tadını çıkarın! 🎉',
    'overview.adminPlaceholder': 'Güncel vardiyalar burada gösterilecek...',
    'overview.notifications': 'Bildirimler',
    'overview.noNotifications': 'Yeni bildirim yok',

    'day.sunday': 'Pazar', 'day.monday': 'Pazartesi', 'day.tuesday': 'Salı',
    'day.wednesday': 'Çarşamba', 'day.thursday': 'Perşembe', 'day.friday': 'Cuma', 'day.saturday': 'Cumartesi',

    'avail.title': 'Çalışan Müsaitlikleri',
    'avail.add': 'Müsaitlik Ekle',
    'avail.filter': 'Filtre',
    'avail.allEmployees': 'Tüm Çalışanlar',
    'avail.onlyYours': 'Sadece kendi müsaitliklerinizi yönetebilirsiniz',
    'avail.withoutAvail': 'Müsaitliği olmayan çalışanlar',
    'avail.selectEmployee': 'Müsaitliği olmayan çalışan seçin...',
    'avail.showWithout': 'Sadece müsaitliği olmayan çalışanları gösterir',
    'avail.dateSpecific': 'Tarihe Özel Müsaitlik',
    'avail.fromDate': 'Başlangıç Tarihi',
    'avail.toDate': 'Bitiş Tarihi',
    'avail.available': 'Müsait',
    'avail.notAvailable': 'Müsait değil',
    'avail.mixed': 'Karışık',
    'avail.selected': 'Seçili',
    'avail.noEntry': 'Giriş yok',
    'avail.weekday': 'Gün',
    'avail.notes': 'Notlar',
    'avail.actions': 'İşlemler',
    'avail.noData': 'Müsaitlik girişi yok',
    'avail.pleaseEnter': 'Lütfen müsaitlik girin',
    'avail.flexible': 'Esnek',
    'avail.morning': 'Sabah',
    'avail.midday': 'Öğle',
    'avail.evening': 'Akşam',
    'avail.custom': 'Özel',
    'avail.editModal': 'Müsaitlik Düzenle',
    'avail.multiModal': 'Birden fazla gün için müsaitlik',
    'avail.newModal': 'Yeni Müsaitlik',
    'avail.multiDays': 'Birden fazla gün aynı anda',
    'avail.type': 'Müsaitlik türü',
    'avail.savedMulti': '{count} gün için müsaitlik başarıyla kaydedildi!',
    'avail.savedPartial': '{count} müsaitlik kaydedildi. Hatalar: {errors}',
    'avail.saved': 'Müsaitlik başarıyla kaydedildi!',
    'avail.deleted': 'Müsaitlik başarıyla silindi',
    'avail.confirmDelete': 'Bu müsaitliği gerçekten silmek istiyor musunuz?',
    'avail.flexTime': '⏰ 07:00 - 01:00 (ertesi gün)',
    'avail.morningTime': '🌅 07:00 - 14:00',
    'avail.middayTime': '☀️ 11:00 - 18:00',
    'avail.eveningTime': '🌙 18:00 - 01:00 (ertesi gün)',
    'avail.customTime': '✏️ Kendi zamanlarınızı girin',
    'avail.selectDate': 'Lütfen en az bir tarih seçin.',
    'avail.selectOneDate': 'Lütfen bir tarih seçin.',
    'avail.autoFlexible': 'Esnek müsait (tüm gün)',
    'avail.autoMorning': 'Esnek müsait (sabah)',
    'avail.autoMidday': 'Esnek müsait (öğle)',
    'avail.autoEvening': 'Esnek müsait (akşam)',
    'avail.save': 'Kaydet',
    'avail.cancel': 'İptal',
    'avail.delete': 'Sil',
    'avail.hintFillAll': 'Lütfen mümkünse her gün için bir şey girin, müsait olmasanız bile. Bu planlama için yardımcı olur.',
    'avail.shortAvailWarning': 'Bu kadar kısa bir müsaitlik süresinde (3 saat veya daha az) gerçek bir görevlendirme daha az olasıdır.',
    'avail.hintOnlyAvail': 'Burada sadece müsaitliğinizi belirtirsiniz – gerçek çalışma saatleriniz bu zaman aralığından planlanır.',
    'avail.existingEntries': 'Mevcut kayıtlar',
    'avail.replaceExisting': 'Mevcut kayıtları değiştir',
    'avail.replaceExistingHint': 'önerilir – bu günün eski saatleri silinir',
    'avail.addWindow': 'Ek zaman aralığı ekle',
    'avail.addWindowHint': 'örn. sabah VE akşam müsait, arada değil',
    'avail.newestEntry': 'son eklenen',
    'avail.olderEntry': 'daha eski kayıt',
    'avail.fullDayFlex': 'Tüm gün (esnek)',
    'avail.noteOptional': 'Not (isteğe bağlı)',
    'avail.alsoApplyTo': 'Ayrıca şunlara uygula:',
    'avail.deselect': 'Seçimi kaldır',
    'avail.additionalDays': '{count} ek gün seçildi',
    'avail.daysHaveEntries': 'seçilen günlerden {count} tanesinde zaten kayıt var',
    'avail.willReplace': 'bunlar değiştirilecek',
    'avail.willAdd': 'yeni zaman aralığı ek olarak eklenecek',
    'avail.switchMode': 'değiştir',
    'avail.update': 'Güncelle',
    'avail.days': 'gün',
    'avail.allDays': 'Tümü',
    'avail.filterFirst': 'Lütfen önce yukarıdan bir çalışan seçin.',
    'avail.calendarView': 'Takvim görünümü',
    'avail.clickDate': 'Müsaitliği düzenlemek için bir tarihe tıklayın',
    'avail.showingFor': 'Gösterilen:',
    'avail.withoutAvailFor': 'Müsaitliği olmayan:',
    'avail.adminFilterFirst': 'Müsaitlik girmek için lütfen önce yukarıdan bir çalışan seçin.',
    'avail.notePlaceholder': 'ör. sadece gerekirse, doktor randevusu...',
    'avail.legendGreen': 'Yeşil',
    'avail.legendRed': 'Kırmızı',
    'avail.legendYellow': 'Sarı',
    'avail.legendBlue': 'Mavi',
    'avail.legendGray': 'Gri',
    'avail.progress': 'İlerleme',
    'avail.statsAvail': 'müsait',
    'avail.statsNotAvail': 'müsait değil',
    'avail.statsOpen': 'açık',

    // Partner
    'partner.title': 'Partner Ekibi',
    'partner.myCode': 'Partner Kodum',
    'partner.copy': 'Kodu kopyala',
    'partner.regenerate': 'Yeni kod oluştur',
    'partner.shareHint': 'Bu kodu birlikte çalışmak istediğiniz iş arkadaşlarınızla paylaşın.',
    'partner.addByCode': 'Partner Ekle',
    'partner.link': 'Bağla',
    'partner.linked': 'Partner başarıyla bağlandı!',
    'partner.unlinked': 'Bağlantı kaldırıldı.',
    'partner.codeRegenerated': 'Yeni partner kodu oluşturuldu.',
    'partner.myPartners': 'Partnerlerim',
    'partner.noPartners': 'Henüz partner bağlanmadı. Kodunuzu arkadaşlarınızla paylaşın!',
    'partner.noEntry': 'Bu gün için kayıt yok',
    'partner.noAccess': 'Erişim yok',
    'partner.visibilityLabel': 'Ortaklarım çalışma saatlerimi görebilir',
    'partner.visibilityHint': 'Etkinleştirildiğinde ortaklarınız müsaitlik durumunuzu görebilir.',
    'partner.shareNumberLabel': 'Ortaklarım telefon numaramı görebilir',
    'partner.shareNumberHint': 'Etkinleştirildiğinde telefon numaranız bağlı ortaklarla paylaşılabilir (ör. WhatsApp üzerinden iletişim için).',
    'partner.visibilityOn': 'Görünürlük etkin',
    'partner.visibilityOff': 'Görünürlük devre dışı',
    'partner.overview': 'Ortak genel görünümü',
    'partner.overviewHint': 'Yalnızca görünürlüğü etkin ortaklar gösterilir. Salt okunur.',
    'partner.refresh': 'Yenile',

    'doc.title': 'Belge Yönetimi',
    'doc.upload': 'Belge Yükle',
    'doc.employee': 'Çalışan *',
    'doc.select': 'Seçin...',
    'doc.docType': 'Belge Türü',
    'doc.selectFile': 'Dosya Seçin *',
    'doc.uploading': 'Yükleniyor...',
    'doc.uploadBtn': 'Yükle',
    'doc.filterEmployee': 'Çalışana göre filtrele',
    'doc.allEmployees': 'Tüm Çalışanlar',
    'doc.overview': 'Belge Özeti',
    'doc.noDocuments': 'Belge bulunamadı',
    'doc.contractTemplate': 'İş Sözleşmesi Şablonu Yönetimi',
    'doc.tabDocuments': 'Belgeler',
    'doc.tabTemplate': 'Sözleşme Şablonu',
    'doc.tabSubmitted': 'Gönderilen Sözleşmeler',
    'doc.tabMyDocs': 'Belgelerim',
    'doc.tabMyContract': 'İş Sözleşmem',
    'doc.filename': 'Dosya adı',
    'doc.type': 'Tür',
    'doc.status': 'Durum',
    'doc.date': 'Tarih',
    'doc.actions': 'İşlemler',
    'doc.view': 'Görüntüle',
    'doc.deleteBtn': 'Sil',
    'doc.uploaded': 'Belge başarıyla yüklendi!',
    'doc.deleted': 'Belge başarıyla silindi!',
    'doc.contractSubmitted': 'İş sözleşmesi başarıyla gönderildi!',
    'doc.contractDraft': 'İş sözleşmesi taslak olarak kaydedildi!',
    'doc.contractDeleted': 'Sözleşme başarıyla silindi!',
    'doc.selectEmployee': 'Lütfen bir çalışan seçin',
    'doc.confirmDelete': '"{name}" belgesini silmek istediğinizden emin misiniz?',
    'doc.confirmContractDelete': 'Bu sözleşmeyi kalıcı olarak silmek istediğinizden emin misiniz?',
    'doc.templateSaved': 'Sözleşme şablonu başarıyla kaydedildi!',
    'doc.statusPending': 'Beklemede',
    'doc.statusApproved': 'Onaylandı',
    'doc.statusRejected': 'Reddedildi',
    'doc.typeContract': 'İş Sözleşmesi',
    'doc.typeAvailability': 'Müsaitlik',
    'doc.typePayslip': 'Bordro',
    'doc.typeResidencePermit': 'Oturma İzni',
    'doc.typeWorkPermit': 'Çalışma İzni',
    'doc.typeOther': 'Diğer',

    'reports.title': 'Vardiya Saatleri {year}',
    'reports.loading': 'Yükleniyor...',
    'reports.loadingYear': '{year} için vardiya saatleri yükleniyor...',
    'reports.selectYear': 'Yıl seçin:',
    'reports.yearHint': 'Seçilen yıl tüm vardiya saatleri ve saat onayları için kullanılır.',
    'reports.tabShifts': 'Planlanan Vardiyalar',
    'reports.tabTimes': 'Gerçek Zamanlar',
    'reports.hourConfirmation': 'Saat Onayı',
    'reports.exportCalendar': 'Takvimi Dışa Aktar',

    'wc.title': '🦽 Tekerlekli Sandalye Yönetimi',
    'wc.refresh': 'Yenile',
    'wc.retry': 'Tekrar dene',
    'wc.totalBookings': 'Toplam Rezervasyon',
    'wc.today': 'Bugün',
    'wc.wheelchairs': 'Tekerlekli Sandalyeler',
    'wc.stations': 'İstasyonlar',
    'wc.filter': 'Filtre',
    'wc.fromDate': 'Başlangıç',
    'wc.toDate': 'Bitiş',
    'wc.resetFilter': 'Filtreyi Sıfırla',
    'wc.bookings': 'Rezervasyonlar ({count})',
    'wc.noBookings': 'Rezervasyon bulunamadı',
    'wc.noBookingsDesc': 'Seçilen dönem için rezervasyon yok.',
    'wc.id': 'ID', 'wc.customer': 'Müşteri', 'wc.phone': 'Telefon',
    'wc.date': 'Tarih', 'wc.startTime': 'Başlangıç', 'wc.endTime': 'Bitiş',
    'wc.wheelchair': 'Tekerlekli Sandalye', 'wc.station': 'İstasyon',
    'wc.remarks': 'Notlar', 'wc.actions': 'İşlemler',
    'wc.wheelchairNum': 'Tekerlekli Sandalye {num}',
    'wc.save': 'Kaydet', 'wc.cancelEdit': 'İptal', 'wc.edit': 'Düzenle', 'wc.delete': 'Sil',
    'wc.confirmDelete': 'Bu rezervasyonu silmek istediğinizden emin misiniz?',
    'wc.loadingData': 'Yükleniyor...', 'wc.loadError': 'Veri yüklenirken hata oluştu',
    'wc.noBookingsForPeriod': 'Seçilen dönem için rezervasyon bulunamadı.',

    'wr.title': '🦽 Tekerlekli Sandalye Kiralama Oktoberfest {year}',
    'wr.hours': 'Oktoberfest açılış saatleri:',
    'wr.period': 'Müsaitlik dönemi: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Gün seçin',
    'wr.step2': '2. Saat seçin',
    'wr.step3': '3. İstasyon ve sandalye seçin',
    'wr.startTime': 'Başlangıç:', 'wr.selectStart': 'Başlangıç saati seçin',
    'wr.endTime': 'Bitiş:', 'wr.selectEnd': 'Bitiş saati seçin',
    'wr.name': 'İsim (zorunlu):', 'wr.namePlaceholder': 'Tam adınız',
    'wr.emailLbl': 'E-posta (isteğe bağlı):',
    'wr.phoneLbl': 'Telefon (isteğe bağlı):', 'wr.phonePlaceholder': 'Telefon numaranız',
    'wr.remarksLbl': 'Notlar (isteğe bağlı):', 'wr.remarksPlaceholder': 'Rezervasyon için ek notlar',
    'wr.hour': '{h}:00',
    'wr.endOfDay': '24:00 (gün sonu)',
    'wr.selectTimeInfo': '{date} için başlangıç ve bitiş saati seçin',
    'wr.checkingAvail': 'Müsaitlik kontrol ediliyor...',
    'wr.selectedPeriod': 'Seçilen dönem:',
    'wr.availableWheelchairs': 'Müsait sandalyeler ({count}):',
    'wr.wheelchairNum': 'Tekerlekli Sandalye {num}',
    'wr.stationName': 'İstasyon: {name}',
    'wr.bookNow': 'Şimdi rezerve et',
    'wr.booking': 'Rezerve ediliyor...',
    'wr.map': '(Harita)',
    'wr.enterName': 'Lütfen önce adınızı girin',
    'wr.bookingSuccess': '✅ Rezervasyon başarılı!',
    'wr.bookingError': 'Rezervasyon Hatası',
    'wr.bookingSuccessMsg': '{date} için rezervasyon başarılı!',
    'wr.newBooking': 'Yeni Rezervasyon',
    'wr.copyDetails': '📋 Detayları kopyala',
    'wr.copied': 'Rezervasyon detayları kopyalandı!',
    'wr.bookingNum': 'Rezervasyon no:', 'wr.bookingName': 'İsim:',
    'wr.bookingWheelchair': 'Sandalye:', 'wr.bookingStation': 'İstasyon:',
    'wr.bookingDate': 'Tarih:', 'wr.bookingTime': 'Saat:',
    'wr.selectDateTime': 'Lütfen tarih, başlangıç ve bitiş saati seçin',
    'wr.endAfterStart': 'Bitiş saati başlangıçtan sonra olmalıdır',
    'wr.enterNameAlert': 'Lütfen adınızı girin',
    'wr.availError': 'Müsaitlik kontrolünde hata',
    'wr.bookingErrorMsg': 'Rezervasyon sırasında hata',
    'wr.noWheelchairs': 'Bu dönem için müsait sandalye yok.',
    'wr.chooseOtherTimes': 'Lütfen başka saatler seçin.',
    'wr.unknownStation': 'Bilinmeyen istasyon',
    'wr.clock': '',
    'wr.backToLogin': 'Girişe dön',
    'day.sunShort': 'Paz', 'day.monShort': 'Pzt', 'day.tueShort': 'Sal',
    'day.wedShort': 'Çar', 'day.thuShort': 'Per', 'day.friShort': 'Cum', 'day.satShort': 'Cmt',

    // Contract Form
    'contract.title': 'Dijital İş Sözleşmesi',
    'contract.loadTemplate': 'Şablonumu yükle',
    'contract.saving': 'Kaydediliyor...',
    'contract.save': 'Kaydet',
    'contract.cancel': 'İptal',
    'contract.edit': 'Düzenle',
    'contract.editContract': 'Sözleşmeyi düzenle',
    'contract.fillContract': 'Sözleşmeyi doldur',
    'contract.printPdf': 'PDF olarak yazdır',
    'contract.contractHeading': 'Kısa Süreli İstihdam Sözleşmesi',
    'contract.between': 'Arasında',
    'contract.and': 've',
    'contract.employeeLabel': 'Çalışan:',
    'contract.nameLabel': 'Soyadı, Adı:',
    'contract.namePlaceholder': 'Soyadı, Adı',
    'contract.toBeFilled': '[Doldurulacak]',
    'contract.address': 'ikamet adresi:',
    'contract.addressPlaceholder': '(Sokak, Numara, Posta Kodu, Şehir)',
    'contract.street': 'Sokak',
    'contract.streetPlaceholder': 'Örnek Sokak',
    'contract.houseNr': 'No.',
    'contract.houseNrPlaceholder': '12a',
    'contract.plz': 'Posta Kodu',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'Şehir',
    'contract.cityPlaceholder': 'Münih',
    'contract.birthdate': 'Doğum tarihi:',
    'contract.nationality': 'Uyruk:',
    'contract.pleaseSelect': 'Lütfen seçin...',
    'contract.workPermitRequired': 'Çalışma izni belgesi gerekli',
    'contract.socialSecNr': 'Sosyal güvenlik numarası:',
    'contract.birthPlace': 'Doğum yeri (Şehir):',
    'contract.taxId': 'Vergi kimlik numarası:',
    'contract.socialBenefits': 'Sosyal yardımlar:',
    'contract.selectOption': 'Lütfen bir seçenek seçin',
    'contract.basicSecurity': 'Temel güvenlik alıyorum',
    'contract.unemployment': 'İşsizlik maaşı alıyorum',
    'contract.pension': 'Emekli maaşı alıyorum',
    'contract.noBenefits': 'Hiçbirini almıyorum',
    'contract.notFilled': '[Doldurulmadı]',
    'contract.idCard': 'Kimlik kartı (ön yüz)',
    'contract.idUploaded': 'Kimlik yüklendi',
    'contract.remove': 'Kaldır',
    'contract.fileTooLarge': 'Dosya çok büyük. Maksimum 10 MB.',
    'contract.idUploadHelper': 'Lütfen kimlik kartınızın ön yüzünün fotoğrafını yükleyin. (Zorunlu, maks. 10 MB)',
    'contract.notUploaded': '[Yüklenmedi]',
    'contract.iban': 'IBAN:',
    'contract.altAccountHolder': 'Farklı hesap sahibi (varsa):',
    'contract.residencePermit': 'Oturma izni / Çalışma izni',
    'contract.nonEuNotice': 'AB dışı uyruk belirttiğiniz için çalışma izni belgesi zorunludur.',
    'contract.docUploaded': 'Belge yüklendi',
    'contract.prevJobs': '2026 yılındaki kısa süreli istihdamlar',
    'contract.noPrevJobs': '2026 yılında kısa süreli istihdam yok.',
    'contract.noPrevJobsCheck': '2026 yılında kısa süreli istihdam yok',
    'contract.from': 'Başlangıç:',
    'contract.to': 'Bitiş:',
    'contract.totalDays': 'Toplam gün:',
    'contract.employer': 'İşveren',
    'contract.actions': 'İşlemler',
    'contract.addJob': 'Başka istihdam ekle',
    'contract.placeDate': 'Yer, Tarih:',
    'contract.placePlaceholder': 'Yer girin *',
    'contract.signedOn': 'İmzalanma tarihi:',
    'contract.notSigned': 'Henüz imzalanmadı',
    'contract.employeeSignature': 'Çalışan imzası',
    'contract.signDigitally': 'Dijital imzala',
    'contract.uploadImage': 'Resim yükle',
    'contract.deleteSignature': 'Sil',
    'contract.employerSignature': 'İşveren imzası',
    'contract.parentSignature': 'Veli imzası',
    'contract.parentNote': '(reşit değilse)',
    'contract.finalize': 'Sözleşmeyi tamamla',
    'contract.finalizeHint': 'Tüm bilgileri kontrol edip sözleşmeyi gönderin.',
    'contract.templateOptions': 'Şablon seçenekleri',
    'contract.templateOptionsHint': 'Verilerinizi gelecekteki sözleşmeler için şablon olarak kaydetmek ister misiniz?',
    'contract.noTemplate': 'Hayır, şablonsuz devam et',
    'contract.yesTemplate': 'Evet, şablon olarak kaydet',
    'contract.deleteTemplateOption': 'Mevcut şablonu sil',
    'contract.submitting': 'Gönderiliyor...',
    'contract.submit': 'Sözleşmeyi gönder',
    'contract.back': 'Geri',
    'contract.saveDraft': 'Taslak olarak kaydet',
    'contract.myContracts': 'Sözleşmelerim',
    'contract.hide': 'Gizle',
    'contract.show': 'Göster',
    'contract.loadingHistory': 'Sözleşme geçmişi yükleniyor...',
    'contract.noContracts': 'Henüz sözleşme oluşturulmadı',
    'contract.digitalSignature': 'Dijital İmza',
    'contract.signatureHint': 'Aşağıdaki alanda fare veya parmağınızla imzalayın:',
    'contract.restart': 'Yeniden başla',
    'contract.acceptSignature': 'İmzayı kabul et',
    'contract.fillRequired': 'Lütfen zorunlu alanları doldurun:',
    'contract.uploadIdCard': 'Lütfen kimlik kartınızın fotoğrafını yükleyin.',
    'contract.selectSocialBenefits': 'Lütfen sosyal yardımlar için bir seçenek seçin.',
    'contract.uploadWorkPermit': 'Lütfen çalışma izni belgenizi yükleyin.',
    'contract.signFirst': 'Lütfen göndermeden önce sözleşmeyi imzalayın.',
    'contract.saveError': 'Sözleşme kaydedilirken hata',
    'contract.submitError': 'Sözleşme gönderilirken hata',
    'contract.fillPrevJobs': 'Lütfen önceki kısa süreli işlerden birini girin veya "2026 yılında kısa süreli iş yapılmadı" seçeneğini işaretleyin.',
    'contract.prevJobsIncomplete': 'Lütfen kısa süreli işi EKSİKSİZ doldurun (başlangıç, bitiş, toplam gün, işveren) – veya satırı silin ya da "kısa süreli iş yapılmadı" seçeneğini işaretleyin.',
    'contract.loadTemplateError': 'Şablon yüklenirken hata',
    'contract.reqName': 'Çalışan adı',
    'contract.reqAddress': 'Çalışan adresi',
    'contract.reqStreet': 'Sokak',
    'contract.reqPLZ': 'Posta kodu',
    'contract.reqCity': 'Şehir',
    'contract.reqBirthdate': 'Doğum tarihi',
    'contract.reqNationality': 'Vatandaşlık',
    'contract.reqSocialSec': 'Sosyal güvenlik numarası',
    'contract.reqBirthPlace': 'Doğum yeri',
    'contract.reqTaxId': 'Vergi numarası',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Yer (imza öncesi)',
    'contract.pdfLanguageNotice': 'Not: Sözleşme PDF Almanca olarak oluşturulacaktır.',
    'contract.pdfTranslationNotice': 'Not: Sözleşme PDF İngilizce olarak oluşturulacaktır.',
  },

  // ==================== POLSKI ====================
  pl: {
    'lug.title': 'Znajdź swój bagaż',
    'lug.subtitle': 'Znajdź swój bagaż',
    'lug.searchHint': 'Wprowadź numer biletu, aby znaleźć właściwą stację odbioru',
    'lug.ticketLabel': 'Numer biletu',
    'lug.ticketPh': 'np. 1234 lub 5678',
    'lug.ticketRange': 'Numery od 1 do 12000',
    'lug.findStation': 'Znajdź stację',
    'lug.notFoundTitle': 'Nie znaleziono stacji',
    'lug.notFoundText': 'Do tego numeru biletu nie można przypisać stacji bagażowej. Sprawdź numer.',
    'lug.pickupStation': 'Twoja stacja odbioru',
    'lug.openMaps': 'Otwórz Google Maps',
    'lug.cantPickup': 'Nie możesz odebrać? Zamów wysyłkę',
    'lug.shippingRequest': 'Prośba o wysyłkę',
    'lug.personalData': 'Dane osobowe',
    'lug.fullName': 'Imię i nazwisko',
    'lug.emailLabel': 'E-mail',
    'lug.phoneLabel': 'Telefon',
    'lug.address': 'Adres',
    'lug.postalCode': 'Kod pocztowy',
    'lug.city': 'Miasto',
    'lug.country': 'Kraj',
    'lug.requiredDocs': 'Wymagane dokumenty',
    'lug.ticketPhoto': 'Zdjęcie biletu',
    'lug.ticketPhotoHint': 'Zdjęcie lub PDF Twojego biletu',
    'lug.dhlLabel': 'Etykieta wysyłkowa DHL',
    'lug.dhlBuyHint': 'Musisz kupić etykietę DHL:',
    'lug.dhlBuy': 'Kup etykietę DHL',
    'lug.dhlImportant': 'Ważne: Upewnij się, że wybrałeś właściwy rozmiar i wagę dla swojego bagażu!',
    'lug.send': 'Wyślij prośbę o wysyłkę',
    'lug.sending': 'Wysyłanie...',
    'lug.cancel': 'Anuluj',
    'lug.successMsg': 'Prośba o wysyłkę została pomyślnie złożona! Otrzymasz e-mail z potwierdzeniem.',
    'lug.refLabel': 'Twój numer referencyjny:',
    'lug.confirmMail': 'Potwierdzenie zostanie wysłane na:',
    'lug.errRequired': 'Wypełnij wszystkie wymagane pola.',
    'lug.errSend': 'Błąd podczas wysyłania prośby',
    'lug.back': 'Powrót do strony głównej',
    'reg.title': 'Aplikacja',
    'reg.subtitle': 'Planowanie personelu Oktoberfest',
    'reg.onlyTitle': 'Tylko dla kandydatów!',
    'reg.onlyText': 'Ten formularz służy wyłącznie do aplikowania jako pracownik. W przypadku usługi wózków inwalidzkich lub wyszukiwania bagażu skorzystaj z linków na stronie głównej.',
    'reg.homepage': 'strona główna',
    'reg.firstname': 'Imię',
    'reg.firstnamePh': 'Twoje imię',
    'reg.lastname': 'Nazwisko',
    'reg.lastnamePh': 'Twoje nazwisko',
    'reg.birthdate': 'Data urodzenia',
    'reg.birthdateHint': 'Służy również jako hasło do logowania',
    'reg.phone': 'Numer telefonu',
    'reg.optional': '(opcjonalnie)',
    'reg.email': 'E-mail',
    'reg.emailOptional': '(opcjonalnie, do potwierdzenia)',
    'reg.submit': 'Aplikuj teraz',
    'reg.submitting': 'Rejestrowanie...',
    'reg.alreadyReg': 'Już zarejestrowany?',
    'reg.toLogin': 'Przejdź do logowania',
    'reg.successTitle': 'Rejestracja udana!',
    'reg.successText': 'Twoje konto zostało utworzone. Możesz teraz zalogować się za pomocą nazwiska i daty urodzenia.',
    'reg.errFirstname': 'Podaj swoje imię',
    'reg.errLastname': 'Podaj swoje nazwisko',
    'reg.errBirthdate': 'Podaj datę urodzenia (DD.MM.RRRR)',
    'reg.errDateFormat': 'Nieprawidłowy format daty',
    'reg.errFailed': 'Rejestracja nie powiodła się. Spróbuj ponownie.',
    'tab.overview': 'Przegląd',
    'tab.users': 'Pracownicy',
    'tab.personalPlanning': 'Przydział Zmian',
    'tab.flexibleShifts': 'Planowanie Zapotrzebowania',
    'tab.tasksAndPlanning': 'Zadania i Planowanie',
    'tab.availability': 'Dostępność',
    'tab.documents': 'Dokumenty',
    'tab.actualHours': 'Rzeczywiste Godziny',
    'tab.reports': 'Zmiany',
    'tab.luggageShipping': 'Wysyłka Bagażu',
    'tab.wheelchairAdmin': 'Wózki\nInwalidzkie',
    'tab.backups': 'Kopie zapasowe',

    'nav.brand': 'Oktoberfest Planowanie Personelu',
    'nav.profile': 'Profil',
    'nav.logout': 'Wyloguj się',
    'nav.user': 'Użytkownik',
    'nav.language': 'Język',

    'approval.title': 'Oczekiwanie na aktywację',
    'approval.description': 'Twoje konto zostało utworzone, ale musi zostać aktywowane przez administratora, zanim będziesz mógł korzystać z zarządzania wózkami.',
    'approval.badge': 'Jeszcze nie aktywowane',

    'overview.title': 'Przegląd',
    'overview.welcome': 'Witaj, {name}!',
    'overview.myShiftsToday': 'Moje zmiany dzisiaj ({date})',
    'overview.planningDraftTitle': '🚧 Grafik zmian jeszcze w przygotowaniu!',
    'overview.planningDraftText': 'To, co tu widzisz, NIE jest jeszcze ostateczne – godziny mogą się zmienić i nie wszystkie dni są zaplanowane. Nie martw się! Gdy grafik będzie gotowy, automatycznie dostaniesz wiadomość WhatsApp. 📲',
    'overview.currentShifts': 'Aktualne Zmiany',
    'overview.loading': 'Ładowanie...',
    'overview.loadingShifts': 'Ładowanie dzisiejszych zmian...',
    'overview.time': 'Czas',
    'overview.station': 'Stanowisko',
    'overview.status': 'Status',
    'overview.planned': 'Zaplanowane',
    'overview.noShifts': 'Nie masz dzisiaj zaplanowanych zmian.',
    'overview.freeDay': 'Ciesz się dniem wolnym! 🎉',
    'overview.adminPlaceholder': 'Tutaj wyświetlane będą aktualne zmiany...',
    'overview.notifications': 'Powiadomienia',
    'overview.noNotifications': 'Brak nowych powiadomień',

    'day.sunday': 'Niedziela', 'day.monday': 'Poniedziałek', 'day.tuesday': 'Wtorek',
    'day.wednesday': 'Środa', 'day.thursday': 'Czwartek', 'day.friday': 'Piątek', 'day.saturday': 'Sobota',

    'avail.title': 'Dostępność Pracowników',
    'avail.add': 'Dodaj Dostępność',
    'avail.filter': 'Filtr',
    'avail.allEmployees': 'Wszyscy Pracownicy',
    'avail.onlyYours': 'Możesz zarządzać tylko swoją dostępnością',
    'avail.available': 'Dostępny',
    'avail.notAvailable': 'Niedostępny',
    'avail.mixed': 'Mieszane',
    'avail.selected': 'Wybrane',
    'avail.noEntry': 'Brak wpisu',
    'avail.weekday': 'Dzień tygodnia',
    'avail.notes': 'Notatki',
    'avail.actions': 'Akcje',
    'avail.noData': 'Brak wpisów dostępności',
    'avail.pleaseEnter': 'Proszę wprowadzić dostępność',
    'avail.flexible': 'Elastyczny',
    'avail.morning': 'Rano',
    'avail.midday': 'Południe',
    'avail.evening': 'Wieczór',
    'avail.custom': 'Własne',
    'avail.editModal': 'Edytuj Dostępność',
    'avail.multiModal': 'Dostępność na kilka dni',
    'avail.newModal': 'Nowa Dostępność',
    'avail.multiDays': 'Kilka dni naraz',
    'avail.type': 'Typ dostępności',
    'avail.saved': 'Dostępność zapisana pomyślnie!',
    'avail.deleted': 'Dostępność usunięta pomyślnie',
    'avail.confirmDelete': 'Czy na pewno chcesz usunąć tę dostępność?',
    'avail.save': 'Zapisz', 'avail.cancel': 'Anuluj', 'avail.delete': 'Usuń',
    'avail.fromDate': 'Od daty', 'avail.toDate': 'Do daty',
    'avail.dateSpecific': 'Dostępność na konkretny dzień',
    'avail.flexTime': '⏰ 07:00 - 01:00 (następny dzień)',
    'avail.morningTime': '🌅 07:00 - 14:00',
    'avail.middayTime': '☀️ 11:00 - 18:00',
    'avail.eveningTime': '🌙 18:00 - 01:00 (następny dzień)',
    'avail.customTime': '✏️ Wprowadź własne godziny',
    'avail.hintFillAll': 'Proszę wpisać coś na każdy dzień, nawet jeśli niedostępny. To pomaga w planowaniu.',
    'avail.shortAvailWarning': 'Przy tak krótkiej dostępności (3 godziny lub mniej) faktyczne przydzielenie staje się mniej prawdopodobne.',
    'avail.hintOnlyAvail': 'Tutaj podajesz tylko swoją dostępność – rzeczywiste godziny pracy zostaną zaplanowane na podstawie tego okna czasowego.',
    'avail.existingEntries': 'Istniejące wpisy',
    'avail.replaceExisting': 'Zastąp istniejące wpisy',
    'avail.replaceExistingHint': 'zalecane – stare godziny na ten dzień zostaną usunięte',
    'avail.addWindow': 'Dodaj dodatkowy przedział czasu',
    'avail.addWindowHint': 'np. dostępny rano I wieczorem, nie pomiędzy',
    'avail.newestEntry': 'ostatnio dodane',
    'avail.olderEntry': 'starszy wpis',
    'avail.fullDayFlex': 'Cały dzień (elastycznie)',
    'avail.noteOptional': 'Notatka (opcjonalnie)',
    'avail.alsoApplyTo': 'Zastosuj również do:',
    'avail.deselect': 'Odznacz',
    'avail.additionalDays': '{count} dodatkowy/ch dzień/dni wybrany/ch',
    'avail.daysHaveEntries': '{count} z wybranych dni ma już wpisy',
    'avail.willReplace': 'zostaną one zastąpione',
    'avail.willAdd': 'nowy przedział czasu zostanie dodany dodatkowo',
    'avail.switchMode': 'przełącz',
    'avail.update': 'Aktualizuj',
    'avail.days': 'dni',
    'avail.allDays': 'Wszystkie',
    'avail.filterFirst': 'Proszę najpierw wybrać pracownika powyżej.',
    'avail.calendarView': 'Widok kalendarza',
    'avail.clickDate': 'Kliknij datę, aby edytować dostępność',
    'avail.showingFor': 'Wyświetlanie dla:',
    'avail.withoutAvailFor': 'Bez dostępności:',
    'avail.adminFilterFirst': 'Proszę najpierw wybrać pracownika, aby wpisać dostępność.',
    'avail.notePlaceholder': 'np. tylko w razie potrzeby, lekarz o 15...',
    'avail.legendGreen': 'Zielony',
    'avail.legendRed': 'Czerwony',
    'avail.legendYellow': 'Żółty',
    'avail.legendBlue': 'Niebieski',
    'avail.legendGray': 'Szary',
    'avail.progress': 'Postęp',
    'avail.statsAvail': 'dostępny',
    'avail.statsNotAvail': 'niedostępny',
    'avail.statsOpen': 'otwarte',

    // Partner
    'partner.title': 'Zespół Partnerski',
    'partner.myCode': 'Mój kod partnera',
    'partner.copy': 'Kopiuj kod',
    'partner.regenerate': 'Wygeneruj nowy kod',
    'partner.shareHint': 'Podziel się tym kodem ze współpracownikami, z którymi chcesz pracować.',
    'partner.addByCode': 'Dodaj partnera',
    'partner.link': 'Połącz',
    'partner.linked': 'Partner pomyślnie połączony!',
    'partner.unlinked': 'Połączenie usunięte.',
    'partner.codeRegenerated': 'Nowy kod partnera wygenerowany.',
    'partner.myPartners': 'Moi partnerzy',
    'partner.noPartners': 'Brak połączonych partnerów. Podziel się kodem ze współpracownikami!',
    'partner.noEntry': 'Brak wpisu na ten dzień',
    'partner.noAccess': 'Brak dostępu',
    'partner.visibilityLabel': 'Moi partnerzy mogą widzieć moje godziny pracy',
    'partner.visibilityHint': 'Po włączeniu partnerzy widzą Twoją dostępność w przeglądzie.',
    'partner.shareNumberLabel': 'Moi partnerzy mogą widzieć mój numer telefonu',
    'partner.shareNumberHint': 'Po włączeniu Twój numer telefonu może być udostępniany połączonym partnerom (np. do kontaktu przez WhatsApp).',
    'partner.visibilityOn': 'Widoczność włączona',
    'partner.visibilityOff': 'Widoczność wyłączona',
    'partner.overview': 'Przegląd partnerów',
    'partner.overviewHint': 'Pokazani są tylko partnerzy z włączoną widocznością. Tylko do odczytu.',
    'partner.refresh': 'Odśwież',

    'doc.title': 'Zarządzanie Dokumentami',
    'doc.upload': 'Prześlij Dokument',
    'doc.employee': 'Pracownik *',
    'doc.select': 'Wybierz...',
    'doc.docType': 'Typ Dokumentu',
    'doc.selectFile': 'Wybierz Plik *',
    'doc.uploading': 'Przesyłanie...',
    'doc.uploadBtn': 'Prześlij',
    'doc.filterEmployee': 'Filtruj po pracowniku',
    'doc.allEmployees': 'Wszyscy Pracownicy',
    'doc.overview': 'Przegląd Dokumentów',
    'doc.noDocuments': 'Brak dokumentów',
    'doc.tabMyDocs': 'Moje Dokumenty',
    'doc.tabMyContract': 'Moja Umowa o Pracę',
    'doc.filename': 'Nazwa pliku',
    'doc.type': 'Typ', 'doc.status': 'Status', 'doc.date': 'Data', 'doc.actions': 'Akcje',
    'doc.view': 'Pokaż', 'doc.deleteBtn': 'Usuń',
    'doc.statusPending': 'Oczekujący',
    'doc.statusApproved': 'Zatwierdzony',
    'doc.statusRejected': 'Odrzucony',
    'doc.typeContract': 'Umowa o Pracę',
    'doc.typeAvailability': 'Dostępność',
    'doc.typePayslip': 'Pasek Wypłaty',
    'doc.typeResidencePermit': 'Pozwolenie na Pobyt',
    'doc.typeWorkPermit': 'Pozwolenie na Pracę',
    'doc.typeOther': 'Inne',

    'reports.title': 'Godziny Zmian {year}',
    'reports.loading': 'Ładowanie...',
    'reports.loadingYear': 'Ładowanie godzin zmian za {year}...',
    'reports.selectYear': 'Wybierz rok:',
    'reports.tabShifts': 'Zaplanowane Zmiany',
    'reports.tabTimes': 'Rzeczywiste Czasy',
    'reports.hourConfirmation': 'Potwierdzenie Godzin',
    'reports.exportCalendar': 'Eksportuj Kalendarz',

    'wc.title': '🦽 Zarządzanie Wózkami Inwalidzkimi',
    'wc.refresh': 'Odśwież', 'wc.retry': 'Spróbuj ponownie',
    'wc.totalBookings': 'Łącznie Rezerwacji', 'wc.today': 'Dzisiaj',
    'wc.wheelchairs': 'Wózki', 'wc.stations': 'Stanowiska',
    'wc.filter': 'Filtr', 'wc.fromDate': 'Od', 'wc.toDate': 'Do',
    'wc.resetFilter': 'Resetuj Filtr',
    'wc.bookings': 'Rezerwacje ({count})',
    'wc.noBookings': 'Nie znaleziono rezerwacji',
    'wc.noBookingsDesc': 'Brak rezerwacji w wybranym okresie.',
    'wc.id': 'ID', 'wc.customer': 'Klient', 'wc.phone': 'Telefon',
    'wc.date': 'Data', 'wc.startTime': 'Start', 'wc.endTime': 'Koniec',
    'wc.wheelchair': 'Wózek', 'wc.station': 'Stanowisko',
    'wc.remarks': 'Uwagi', 'wc.actions': 'Akcje',
    'wc.wheelchairNum': 'Wózek {num}',
    'wc.save': 'Zapisz', 'wc.cancelEdit': 'Anuluj', 'wc.edit': 'Edytuj', 'wc.delete': 'Usuń',
    'wc.confirmDelete': 'Czy na pewno chcesz usunąć tę rezerwację?',
    'wc.loadingData': 'Ładowanie...', 'wc.loadError': 'Błąd ładowania danych',
    'wc.noBookingsForPeriod': 'Brak rezerwacji w wybranym okresie.',

    'wr.title': '🦽 Wypożyczalnia Wózków Oktoberfest {year}',
    'wr.hours': 'Godziny otwarcia podczas Oktoberfestu:',
    'wr.period': 'Okres dostępności: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Wybierz dzień',
    'wr.step2': '2. Wybierz godzinę',
    'wr.step3': '3. Wybierz stanowisko i wózek',
    'wr.startTime': 'Start:', 'wr.selectStart': 'Wybierz godzinę startu',
    'wr.endTime': 'Koniec:', 'wr.selectEnd': 'Wybierz godzinę końca',
    'wr.name': 'Imię i nazwisko (wymagane):', 'wr.namePlaceholder': 'Pełne imię i nazwisko',
    'wr.emailLbl': 'E-mail (opcjonalnie):',
    'wr.phoneLbl': 'Telefon (opcjonalnie):', 'wr.phonePlaceholder': 'Numer telefonu',
    'wr.remarksLbl': 'Uwagi (opcjonalnie):', 'wr.remarksPlaceholder': 'Dodatkowe uwagi',
    'wr.hour': '{h}:00', 'wr.endOfDay': '24:00 (koniec dnia)',
    'wr.selectTimeInfo': 'Wybierz godzinę startu i końca na {date}',
    'wr.checkingAvail': 'Sprawdzanie dostępności...',
    'wr.selectedPeriod': 'Wybrany okres:',
    'wr.availableWheelchairs': 'Dostępne wózki ({count}):',
    'wr.wheelchairNum': 'Wózek {num}',
    'wr.stationName': 'Stanowisko: {name}',
    'wr.bookNow': 'Zarezerwuj teraz', 'wr.booking': 'Rezerwacja...',
    'wr.map': '(Mapa)', 'wr.enterName': 'Proszę najpierw wpisać imię',
    'wr.bookingSuccess': '✅ Rezerwacja udana!',
    'wr.bookingError': 'Błąd Rezerwacji',
    'wr.bookingSuccessMsg': 'Rezerwacja na {date} udana!',
    'wr.newBooking': 'Nowa Rezerwacja',
    'wr.copyDetails': '📋 Kopiuj szczegóły',
    'wr.copied': 'Szczegóły rezerwacji skopiowane!',
    'wr.bookingNum': 'Nr rezerwacji:', 'wr.bookingName': 'Imię:',
    'wr.bookingWheelchair': 'Wózek:', 'wr.bookingStation': 'Stanowisko:',
    'wr.bookingDate': 'Data:', 'wr.bookingTime': 'Godzina:',
    'wr.selectDateTime': 'Proszę wybrać datę, godzinę startu i końca',
    'wr.endAfterStart': 'Godzina końca musi być po godzinie startu',
    'wr.enterNameAlert': 'Proszę wpisać imię',
    'wr.noWheelchairs': 'Brak dostępnych wózków w tym okresie.',
    'wr.chooseOtherTimes': 'Proszę wybrać inne godziny.',
    'wr.unknownStation': 'Nieznana stacja',
    'wr.clock': '',
    'wr.backToLogin': 'Powrót do logowania',
    'day.sunShort': 'Nd', 'day.monShort': 'Pn', 'day.tueShort': 'Wt',
    'day.wedShort': 'Śr', 'day.thuShort': 'Czw', 'day.friShort': 'Pt', 'day.satShort': 'Sob',

    // Contract Form
    'contract.title': 'Cyfrowa Umowa o Pracę',
    'contract.loadTemplate': 'Załaduj mój szablon',
    'contract.saving': 'Zapisywanie...',
    'contract.save': 'Zapisz',
    'contract.cancel': 'Anuluj',
    'contract.edit': 'Edytuj',
    'contract.editContract': 'Edytuj umowę',
    'contract.fillContract': 'Wypełnij umowę',
    'contract.printPdf': 'Drukuj jako PDF',
    'contract.contractHeading': 'Umowa o Krótkoterminowe Zatrudnienie',
    'contract.between': 'Pomiędzy',
    'contract.and': 'a',
    'contract.employeeLabel': 'Pracownik:',
    'contract.nameLabel': 'Nazwisko, Imię:',
    'contract.namePlaceholder': 'Nazwisko, Imię',
    'contract.toBeFilled': '[Do wypełnienia]',
    'contract.address': 'zamieszkały/a:',
    'contract.addressPlaceholder': '(Ulica, Numer, Kod pocztowy, Miasto)',
    'contract.street': 'Ulica',
    'contract.streetPlaceholder': 'ul. Przykładowa',
    'contract.houseNr': 'Nr',
    'contract.houseNrPlaceholder': '12a',
    'contract.plz': 'Kod pocztowy',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'Miasto',
    'contract.cityPlaceholder': 'Monachium',
    'contract.birthdate': 'Data urodzenia:',
    'contract.nationality': 'Obywatelstwo:',
    'contract.pleaseSelect': 'Proszę wybrać...',
    'contract.workPermitRequired': 'Wymagane pozwolenie na pracę',
    'contract.socialSecNr': 'Numer ubezpieczenia społecznego:',
    'contract.birthPlace': 'Miejsce urodzenia (Miasto):',
    'contract.taxId': 'Numer identyfikacji podatkowej:',
    'contract.socialBenefits': 'Świadczenia socjalne:',
    'contract.selectOption': 'Proszę wybrać opcję',
    'contract.basicSecurity': 'Otrzymuję zasiłek socjalny',
    'contract.unemployment': 'Otrzymuję zasiłek dla bezrobotnych',
    'contract.pension': 'Otrzymuję emeryturę',
    'contract.noBenefits': 'Nie otrzymuję żadnego z powyższych',
    'contract.notFilled': '[Nie wypełniono]',
    'contract.idCard': 'Dowód osobisty (przód)',
    'contract.idUploaded': 'Dowód załadowany',
    'contract.remove': 'Usuń',
    'contract.fileTooLarge': 'Plik jest za duży. Maksymalnie 10 MB.',
    'contract.idUploadHelper': 'Proszę załadować zdjęcie przedniej strony dowodu osobistego. (Wymagane, maks. 10 MB)',
    'contract.notUploaded': '[Nie załadowano]',
    'contract.iban': 'IBAN:',
    'contract.altAccountHolder': 'Inny posiadacz konta (jeśli dotyczy):',
    'contract.residencePermit': 'Pozwolenie na pobyt / Pozwolenie na pracę',
    'contract.nonEuNotice': 'Ponieważ podano obywatelstwo spoza UE, wymagany jest dowód pozwolenia na pracę.',
    'contract.docUploaded': 'Dokument załadowany',
    'contract.prevJobs': 'Poprzednie zatrudnienia krótkoterminowe w 2026',
    'contract.noPrevJobs': 'Brak krótkoterminowego zatrudnienia w 2026.',
    'contract.noPrevJobsCheck': 'brak krótkoterminowego zatrudnienia w 2026',
    'contract.from': 'Od:',
    'contract.to': 'Do:',
    'contract.totalDays': 'Łącznie dni:',
    'contract.employer': 'Pracodawca',
    'contract.actions': 'Akcje',
    'contract.addJob': 'Dodaj kolejne zatrudnienie',
    'contract.placeDate': 'Miejsce, Data:',
    'contract.placePlaceholder': 'Wpisz miejsce *',
    'contract.signedOn': 'Podpisano:',
    'contract.notSigned': 'Jeszcze nie podpisano',
    'contract.employeeSignature': 'Podpis pracownika',
    'contract.signDigitally': 'Podpisz cyfrowo',
    'contract.uploadImage': 'Załaduj obraz',
    'contract.deleteSignature': 'Usuń',
    'contract.employerSignature': 'Podpis pracodawcy',
    'contract.parentSignature': 'Podpis opiekuna',
    'contract.parentNote': '(jeśli niepełnoletni)',
    'contract.finalize': 'Zakończ umowę',
    'contract.finalizeHint': 'Sprawdź wszystkie dane i wyślij umowę.',
    'contract.templateOptions': 'Opcje szablonu',
    'contract.templateOptionsHint': 'Czy chcesz zapisać dane jako szablon?',
    'contract.noTemplate': 'Nie, kontynuuj bez szablonu',
    'contract.yesTemplate': 'Tak, zapisz jako szablon',
    'contract.deleteTemplateOption': 'Usuń istniejący szablon',
    'contract.submitting': 'Wysyłanie...',
    'contract.submit': 'Wyślij umowę',
    'contract.back': 'Wstecz',
    'contract.saveDraft': 'Zapisz jako wersję roboczą',
    'contract.myContracts': 'Moje Umowy',
    'contract.hide': 'Ukryj',
    'contract.show': 'Pokaż',
    'contract.noContracts': 'Brak utworzonych umów',
    'contract.digitalSignature': 'Podpis Cyfrowy',
    'contract.signatureHint': 'Podpisz się myszką lub palcem poniżej:',
    'contract.restart': 'Zacznij od nowa',
    'contract.acceptSignature': 'Zaakceptuj podpis',
    'contract.fillRequired': 'Proszę wypełnić wymagane pola:',
    'contract.uploadIdCard': 'Proszę załadować zdjęcie dowodu.',
    'contract.selectSocialBenefits': 'Proszę wybrać opcję świadczeń.',
    'contract.uploadWorkPermit': 'Proszę załadować dokument pozwolenia na pracę.',
    'contract.signFirst': 'Proszę podpisać umowę przed wysłaniem.',
    'contract.saveError': 'Błąd podczas zapisywania umowy',
    'contract.submitError': 'Błąd podczas wysyłania umowy',
    'contract.fillPrevJobs': 'Proszę podać poprzednie krótkoterminowe zatrudnienie lub zaznaczyć "brak krótkoterminowego zatrudnienia w 2026".',
    'contract.prevJobsIncomplete': 'Proszę CAŁKOWICIE wypełnić krótkoterminowe zatrudnienie (od, do, łączna liczba dni, pracodawca) – albo usunąć wiersz lub zaznaczyć "brak krótkoterminowego zatrudnienia".',
    'contract.loadTemplateError': 'Błąd ładowania szablonu',
    'contract.reqName': 'Nazwisko pracownika',
    'contract.reqAddress': 'Adres pracownika',
    'contract.reqStreet': 'Ulica',
    'contract.reqPLZ': 'Kod pocztowy',
    'contract.reqCity': 'Miasto',
    'contract.reqBirthdate': 'Data urodzenia',
    'contract.reqNationality': 'Obywatelstwo',
    'contract.reqSocialSec': 'Numer ubezpieczenia społecznego',
    'contract.reqBirthPlace': 'Miejsce urodzenia',
    'contract.reqTaxId': 'Numer identyfikacji podatkowej',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Miejsce (przed podpisem)',
    'contract.pdfLanguageNotice': 'Uwaga: Umowa PDF zostanie utworzona w języku niemieckim.',
    'contract.pdfTranslationNotice': 'Uwaga: Umowa PDF zostanie utworzona w języku angielskim.',
  },

  // ==================== ROMÂNĂ ====================
  ro: {
    'lug.title': 'Găsește-ți bagajul',
    'lug.subtitle': 'Găsește-ți bagajul',
    'lug.searchHint': 'Introduceți numărul biletului pentru a găsi stația de ridicare corectă',
    'lug.ticketLabel': 'Număr bilet',
    'lug.ticketPh': 'ex. 1234 sau 5678',
    'lug.ticketRange': 'Numere de la 1 la 12000',
    'lug.findStation': 'Găsește stația',
    'lug.notFoundTitle': 'Nicio stație găsită',
    'lug.notFoundText': 'Nu s-a putut asocia nicio stație de bagaje acestui număr de bilet. Vă rugăm verificați numărul.',
    'lug.pickupStation': 'Stația dvs. de ridicare',
    'lug.openMaps': 'Deschide Google Maps',
    'lug.cantPickup': 'Nu puteți ridica? Solicitați expediere',
    'lug.shippingRequest': 'Cerere de expediere',
    'lug.personalData': 'Date personale',
    'lug.fullName': 'Nume complet',
    'lug.emailLabel': 'E-mail',
    'lug.phoneLabel': 'Telefon',
    'lug.address': 'Adresă',
    'lug.postalCode': 'Cod poștal',
    'lug.city': 'Oraș',
    'lug.country': 'Țară',
    'lug.requiredDocs': 'Documente necesare',
    'lug.ticketPhoto': 'Foto bilet',
    'lug.ticketPhotoHint': 'Fotografie sau PDF al biletului dvs.',
    'lug.dhlLabel': 'Etichetă de expediere DHL',
    'lug.dhlBuyHint': 'Trebuie să cumpărați o etichetă DHL:',
    'lug.dhlBuy': 'Cumpără etichetă DHL',
    'lug.dhlImportant': 'Important: Asigurați-vă că alegeți dimensiunea și greutatea corecte pentru bagajul dvs.!',
    'lug.send': 'Trimite cererea de expediere',
    'lug.sending': 'Se trimite...',
    'lug.cancel': 'Anulează',
    'lug.successMsg': 'Cererea de expediere a fost trimisă cu succes! Veți primi un e-mail de confirmare.',
    'lug.refLabel': 'Numărul dvs. de referință:',
    'lug.confirmMail': 'Confirmarea va fi trimisă la:',
    'lug.errRequired': 'Vă rugăm completați toate câmpurile obligatorii.',
    'lug.errSend': 'Eroare la trimiterea cererii',
    'lug.back': 'Înapoi la pagina principală',
    'reg.title': 'Aplicație',
    'reg.subtitle': 'Planificarea personalului Oktoberfest',
    'reg.onlyTitle': 'Doar pentru candidați!',
    'reg.onlyText': 'Acest formular este exclusiv pentru a candida ca angajat. Pentru serviciul de scaune cu rotile sau căutarea bagajelor, vă rugăm să folosiți linkurile de pe pagina principală.',
    'reg.homepage': 'pagina principală',
    'reg.firstname': 'Prenume',
    'reg.firstnamePh': 'Prenumele dvs.',
    'reg.lastname': 'Nume',
    'reg.lastnamePh': 'Numele dvs.',
    'reg.birthdate': 'Data nașterii',
    'reg.birthdateHint': 'Servește totodată drept parolă pentru autentificare',
    'reg.phone': 'Număr de telefon',
    'reg.optional': '(opțional)',
    'reg.email': 'E-mail',
    'reg.emailOptional': '(opțional, pentru confirmare)',
    'reg.submit': 'Aplică acum',
    'reg.submitting': 'Se înregistrează...',
    'reg.alreadyReg': 'Deja înregistrat?',
    'reg.toLogin': 'Mergi la autentificare',
    'reg.successTitle': 'Înregistrare reușită!',
    'reg.successText': 'Contul dvs. a fost creat. Vă puteți autentifica acum cu numele și data nașterii.',
    'reg.errFirstname': 'Vă rugăm să introduceți prenumele',
    'reg.errLastname': 'Vă rugăm să introduceți numele',
    'reg.errBirthdate': 'Vă rugăm să introduceți data nașterii (ZZ.LL.AAAA)',
    'reg.errDateFormat': 'Format de dată invalid',
    'reg.errFailed': 'Înregistrarea a eșuat. Vă rugăm să încercați din nou.',
    'tab.overview': 'Prezentare generală',
    'tab.users': 'Angajați',
    'tab.personalPlanning': 'Alocarea Turelor',
    'tab.flexibleShifts': 'Planificarea Necesarului',
    'tab.tasksAndPlanning': 'Sarcini și Planificare',
    'tab.availability': 'Disponibilitate',
    'tab.documents': 'Documente',
    'tab.actualHours': 'Ore Reale',
    'tab.reports': 'Ture',
    'tab.luggageShipping': 'Expediere Bagaje',
    'tab.wheelchairAdmin': 'Scaune\ncu Rotile',
    'tab.backups': 'Backup-uri',

    'nav.brand': 'Oktoberfest Planificare Personal',
    'nav.profile': 'Profil',
    'nav.logout': 'Deconectare',
    'nav.user': 'Utilizator',
    'nav.language': 'Limbă',

    'approval.title': 'Se așteaptă activarea',
    'approval.description': 'Contul a fost creat, dar trebuie activat de un administrator înainte de a putea utiliza administrarea scaunelor cu rotile.',
    'approval.badge': 'Încă neactivat',

    'overview.title': 'Prezentare generală',
    'overview.welcome': 'Bine ați venit, {name}!',
    'overview.myShiftsToday': 'Turele mele azi ({date})',
    'overview.planningDraftTitle': '🚧 Planificarea turelor este încă în lucru!',
    'overview.planningDraftText': 'Ce vezi aici NU este încă final – orele se pot schimba și nu toate zilele sunt planificate. Nu te îngrijora! Când planul tău va fi final, vei primi automat un mesaj WhatsApp. 📲',
    'overview.currentShifts': 'Ture Curente',
    'overview.loading': 'Se încarcă...',
    'overview.loadingShifts': 'Se încarcă turele de azi...',
    'overview.time': 'Ora',
    'overview.station': 'Stație',
    'overview.status': 'Status',
    'overview.planned': 'Planificat',
    'overview.noShifts': 'Nu aveți ture planificate azi.',
    'overview.freeDay': 'Bucurați-vă de ziua liberă! 🎉',
    'overview.notifications': 'Notificări',
    'overview.noNotifications': 'Nicio notificare nouă',

    'day.sunday': 'Duminică', 'day.monday': 'Luni', 'day.tuesday': 'Marți',
    'day.wednesday': 'Miercuri', 'day.thursday': 'Joi', 'day.friday': 'Vineri', 'day.saturday': 'Sâmbătă',

    'avail.title': 'Disponibilitatea Angajaților',
    'avail.add': 'Adaugă Disponibilitate',
    'avail.filter': 'Filtru',
    'avail.allEmployees': 'Toți Angajații',
    'avail.onlyYours': 'Puteți gestiona doar propria disponibilitate',
    'avail.available': 'Disponibil',
    'avail.notAvailable': 'Indisponibil',
    'avail.mixed': 'Mixt',
    'avail.selected': 'Selectat',
    'avail.noEntry': 'Niciun articol',
    'avail.weekday': 'Zi',
    'avail.notes': 'Note',
    'avail.actions': 'Acțiuni',
    'avail.noData': 'Nicio intrare de disponibilitate',
    'avail.pleaseEnter': 'Vă rugăm introduceți disponibilitatea',
    'avail.flexible': 'Flexibil',
    'avail.morning': 'Dimineața',
    'avail.midday': 'Prânz',
    'avail.evening': 'Seara',
    'avail.custom': 'Personalizat',
    'avail.saved': 'Disponibilitate salvată cu succes!',
    'avail.deleted': 'Disponibilitate ștearsă cu succes',
    'avail.confirmDelete': 'Sigur doriți să ștergeți această disponibilitate?',
    'avail.save': 'Salvare', 'avail.cancel': 'Anulare', 'avail.delete': 'Ștergere',
    'avail.fromDate': 'De la data', 'avail.toDate': 'Până la data',
    'avail.hintFillAll': 'Vă rugăm să completați ceva pentru fiecare zi, chiar dacă nu sunteți disponibil. Acest lucru ajută la planificare.',
    'avail.shortAvailWarning': 'Cu o disponibilitate atât de scurtă (3 ore sau mai puțin), o atribuire efectivă devine mai puțin probabilă.',
    'avail.hintOnlyAvail': 'Aici indicați doar disponibilitatea – orele efective de lucru vor fi planificate din acest interval.',
    'avail.existingEntries': 'Înregistrări existente',
    'avail.replaceExisting': 'Înlocuiește înregistrările existente',
    'avail.replaceExistingHint': 'recomandat – orele vechi pentru această zi vor fi șterse',
    'avail.addWindow': 'Adaugă un interval suplimentar',
    'avail.addWindowHint': 'de ex. disponibil dimineața ȘI seara, nu între ele',
    'avail.newestEntry': 'ultima înregistrare',
    'avail.olderEntry': 'înregistrare mai veche',
    'avail.fullDayFlex': 'Toată ziua (flexibil)',
    'avail.noteOptional': 'Notă (opțional)',
    'avail.alsoApplyTo': 'Aplică și la:',
    'avail.deselect': 'Deselectați',
    'avail.additionalDays': 'Încă {count} zi(le) selectată(e)',
    'avail.daysHaveEntries': '{count} dintre zilele selectate au deja înregistrări',
    'avail.willReplace': 'acestea vor fi înlocuite',
    'avail.willAdd': 'noul interval se adaugă în plus',
    'avail.switchMode': 'comută',
    'avail.update': 'Actualizați',
    'avail.days': 'zile',
    'avail.allDays': 'Toate',
    'avail.filterFirst': 'Vă rugăm să selectați mai întâi un angajat de mai sus.',
    'avail.calendarView': 'Vizualizare calendar',
    'avail.clickDate': 'Faceți clic pe o dată pentru a edita disponibilitatea',
    'avail.showingFor': 'Afișare pentru:',
    'avail.withoutAvailFor': 'Fără disponibilitate:',
    'avail.adminFilterFirst': 'Vă rugăm să selectați mai întâi un angajat pentru a introduce disponibilitatea.',
    'avail.notePlaceholder': 'ex. doar dacă e necesar, medic la 15...',
    'avail.legendGreen': 'Verde',
    'avail.legendRed': 'Roșu',
    'avail.legendYellow': 'Galben',
    'avail.legendBlue': 'Albastru',
    'avail.legendGray': 'Gri',
    'avail.progress': 'Progres',
    'avail.statsAvail': 'disponibil',
    'avail.statsNotAvail': 'indisponibil',
    'avail.statsOpen': 'deschis',

    // Partner
    'partner.title': 'Echipa de Parteneri',
    'partner.myCode': 'Codul meu de partener',
    'partner.copy': 'Copiază codul',
    'partner.regenerate': 'Generează cod nou',
    'partner.shareHint': 'Împartește acest cod cu colegii cu care dorești să lucrezi.',
    'partner.addByCode': 'Adaugă partener',
    'partner.link': 'Leagă',
    'partner.linked': 'Partener conectat cu succes!',
    'partner.unlinked': 'Conexiune îndepărtată.',
    'partner.codeRegenerated': 'Cod nou de partener generat.',
    'partner.myPartners': 'Partenerii mei',
    'partner.noPartners': 'Niciun partener conectat încă. Împartește codul cu colegii!',
    'partner.noEntry': 'Nicio înregistrare pentru această zi',
    'partner.noAccess': 'Fără acces',
    'partner.visibilityLabel': 'Partenerii mei pot vedea orele mele de lucru',
    'partner.visibilityHint': 'Când este activat, partenerii tăi pot vedea disponibilitatea ta.',
    'partner.shareNumberLabel': 'Partenerii mei îmi pot vedea numărul de telefon',
    'partner.shareNumberHint': 'Când este activat, numărul tău de telefon poate fi partajat cu partenerii conectați (de ex. pentru coordonare pe WhatsApp).',
    'partner.visibilityOn': 'Vizibilitate activată',
    'partner.visibilityOff': 'Vizibilitate dezactivată',
    'partner.overview': 'Privire de ansamblu parteneri',
    'partner.overviewHint': 'Sunt afișați doar partenerii cu vizibilitate activată. Doar citire.',
    'partner.refresh': 'Reîmprospătare',

    'doc.title': 'Gestionarea Documentelor',
    'doc.tabMyDocs': 'Documentele Mele',
    'doc.tabMyContract': 'Contractul Meu de Muncă',
    'doc.noDocuments': 'Niciun document disponibil',
    'doc.typeContract': 'Contract de Muncă',
    'doc.typePayslip': 'Fluturasul de Salariu',
    'doc.typeResidencePermit': 'Permis de Ședere',
    'doc.typeWorkPermit': 'Permis de Muncă',
    'doc.typeOther': 'Altele',
    'doc.statusPending': 'În așteptare',
    'doc.statusApproved': 'Aprobat',
    'doc.statusRejected': 'Respins',

    'reports.title': 'Ore de Lucru {year}',
    'reports.loading': 'Se încarcă...',
    'reports.selectYear': 'Selectați anul:',
    'reports.tabShifts': 'Ture Planificate',
    'reports.tabTimes': 'Ore Reale',
    'reports.hourConfirmation': 'Confirmarea Orelor',
    'reports.exportCalendar': 'Exportă Calendar',

    'wc.title': '🦽 Administrare Scaune cu Rotile',
    'wc.refresh': 'Actualizează', 'wc.retry': 'Încearcă din nou',
    'wc.totalBookings': 'Total Rezervări', 'wc.today': 'Azi',
    'wc.wheelchairs': 'Scaune cu Rotile', 'wc.stations': 'Stații',
    'wc.filter': 'Filtru', 'wc.fromDate': 'De la', 'wc.toDate': 'Până la',
    'wc.resetFilter': 'Resetează Filtru',
    'wc.bookings': 'Rezervări ({count})',
    'wc.noBookings': 'Nicio rezervare găsită',
    'wc.wheelchairNum': 'Scaun {num}',
    'wc.save': 'Salvare', 'wc.cancelEdit': 'Anulare', 'wc.edit': 'Editare', 'wc.delete': 'Ștergere',
    'wc.confirmDelete': 'Sigur doriți să ștergeți această rezervare?',
    'wc.loadingData': 'Se încarcă...', 'wc.loadError': 'Eroare la încărcarea datelor',
    'wc.noBookingsForPeriod': 'Nu există rezervări pentru perioada selectată.',

    'wr.title': '🦽 Închiriere Scaune cu Rotile Oktoberfest {year}',
    'wr.hours': 'Program în timpul Oktoberfestului:',
    'wr.period': 'Perioada de disponibilitate: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Selectați ziua',
    'wr.step2': '2. Selectați ora',
    'wr.step3': '3. Alegeți stația și scaunul',
    'wr.startTime': 'Ora de start:', 'wr.selectStart': 'Selectați ora de start',
    'wr.endTime': 'Ora de sfârșit:', 'wr.selectEnd': 'Selectați ora de sfârșit',
    'wr.name': 'Nume (obligatoriu):', 'wr.namePlaceholder': 'Numele complet',
    'wr.emailLbl': 'E-mail (opțional):',
    'wr.phoneLbl': 'Telefon (opțional):', 'wr.phonePlaceholder': 'Numărul de telefon',
    'wr.remarksLbl': 'Observații (opțional):', 'wr.remarksPlaceholder': 'Observații suplimentare',
    'wr.bookNow': 'Rezervă acum', 'wr.booking': 'Se rezervă...',
    'wr.bookingSuccess': '✅ Rezervare reușită!',
    'wr.bookingSuccessMsg': 'Rezervare reușită pentru {date}!',
    'wr.newBooking': 'Rezervare Nouă',
    'wr.copyDetails': '📋 Copiază detalii',
    'wr.copied': 'Detalii copiate!',
    'wr.noWheelchairs': 'Niciun scaun cu rotile disponibil pentru această perioadă.',
    'wr.chooseOtherTimes': 'Vă rugăm să alegeți alte ore.',
    'wr.unknownStation': 'Stație necunoscută',
    'wr.clock': '',
    'wr.backToLogin': 'Înapoi la autentificare',
    'day.sunShort': 'Dum', 'day.monShort': 'Lun', 'day.tueShort': 'Mar',
    'day.wedShort': 'Mie', 'day.thuShort': 'Joi', 'day.friShort': 'Vin', 'day.satShort': 'Sâm',

    // Contract Form
    'contract.title': 'Contract de Muncă Digital',
    'contract.loadTemplate': 'Încarcă șablonul meu',
    'contract.saving': 'Se salvează...',
    'contract.save': 'Salvează',
    'contract.cancel': 'Anulează',
    'contract.edit': 'Editează',
    'contract.editContract': 'Editează contractul',
    'contract.fillContract': 'Completează contractul',
    'contract.printPdf': 'Tipărește ca PDF',
    'contract.contractHeading': 'Contract de Angajare pe Termen Scurt',
    'contract.between': 'Între',
    'contract.and': 'și',
    'contract.employeeLabel': 'Angajat:',
    'contract.nameLabel': 'Nume, Prenume:',
    'contract.namePlaceholder': 'Nume, Prenume',
    'contract.toBeFilled': '[De completat]',
    'contract.address': 'domiciliat/ă:',
    'contract.addressPlaceholder': '(Stradă, Număr, Cod poștal, Oraș)',
    'contract.street': 'Stradă',
    'contract.streetPlaceholder': 'Str. Exemplu',
    'contract.houseNr': 'Nr.',
    'contract.houseNrPlaceholder': '12a',
    'contract.plz': 'Cod poștal',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'Oraș',
    'contract.cityPlaceholder': 'München',
    'contract.birthdate': 'Data nașterii:',
    'contract.nationality': 'Cetățenie:',
    'contract.pleaseSelect': 'Vă rugăm selectați...',
    'contract.workPermitRequired': 'Permis de muncă necesar',
    'contract.socialSecNr': 'Număr asigurare socială:',
    'contract.birthPlace': 'Locul nașterii (Oraș):',
    'contract.taxId': 'Cod de identificare fiscală:',
    'contract.socialBenefits': 'Prestații sociale:',
    'contract.selectOption': 'Selectați o opțiune',
    'contract.basicSecurity': 'Primesc ajutor social',
    'contract.unemployment': 'Primesc ajutor de șomaj',
    'contract.pension': 'Primesc pensie',
    'contract.noBenefits': 'Nu primesc nimic din cele de mai sus',
    'contract.notFilled': '[Necompletat]',
    'contract.idCard': 'Carte de identitate (față)',
    'contract.idUploaded': 'CI încărcată',
    'contract.remove': 'Elimină',
    'contract.fileTooLarge': 'Fișierul este prea mare. Maximum 10 MB.',
    'contract.idUploadHelper': 'Încărcați o fotografie a părții frontale a cărții de identitate. (Obligatoriu, max. 10 MB)',
    'contract.notUploaded': '[Neîncărcat]',
    'contract.iban': 'IBAN:',
    'contract.altAccountHolder': 'Alt titular de cont (dacă este cazul):',
    'contract.residencePermit': 'Permis de ședere / Permis de muncă',
    'contract.nonEuNotice': 'Deoarece ați specificat cetățenie non-UE, este necesar un document de permis de muncă.',
    'contract.docUploaded': 'Document încărcat',
    'contract.prevJobs': 'Angajări anterioare pe termen scurt în 2026',
    'contract.noPrevJobs': 'Nicio angajare pe termen scurt în 2026.',
    'contract.noPrevJobsCheck': 'nicio angajare pe termen scurt în 2026',
    'contract.from': 'De la:',
    'contract.to': 'Până la:',
    'contract.totalDays': 'Total zile:',
    'contract.employer': 'Angajator',
    'contract.actions': 'Acțiuni',
    'contract.addJob': 'Adaugă o altă angajare',
    'contract.placeDate': 'Loc, Data:',
    'contract.placePlaceholder': 'Introduceți locul *',
    'contract.signedOn': 'Semnat pe:',
    'contract.notSigned': 'Nesemnat încă',
    'contract.employeeSignature': 'Semnătura angajatului',
    'contract.signDigitally': 'Semnați digital',
    'contract.uploadImage': 'Încarcă imagine',
    'contract.deleteSignature': 'Șterge',
    'contract.employerSignature': 'Semnătura angajatorului',
    'contract.parentSignature': 'Semnătura tutorelui',
    'contract.parentNote': '(dacă este minor)',
    'contract.finalize': 'Finalizează contractul',
    'contract.finalizeHint': 'Verificați toate datele și trimiteți contractul.',
    'contract.templateOptions': 'Opțiuni șablon',
    'contract.templateOptionsHint': 'Doriți să salvați datele ca șablon?',
    'contract.noTemplate': 'Nu, continuă fără șablon',
    'contract.yesTemplate': 'Da, salvează ca șablon',
    'contract.deleteTemplateOption': 'Șterge șablonul existent',
    'contract.submitting': 'Se trimite...',
    'contract.submit': 'Trimite contractul',
    'contract.back': 'Înapoi',
    'contract.saveDraft': 'Salvează ca ciornă',
    'contract.myContracts': 'Contractele Mele',
    'contract.hide': 'Ascunde',
    'contract.show': 'Arată',
    'contract.noContracts': 'Niciun contract creat încă',
    'contract.digitalSignature': 'Semnătură Digitală',
    'contract.signatureHint': 'Semnați cu mouse-ul sau degetul mai jos:',
    'contract.restart': 'Începe din nou',
    'contract.acceptSignature': 'Acceptă semnătura',
    'contract.fillRequired': 'Completați câmpurile obligatorii:',
    'contract.uploadIdCard': 'Încărcați fotografia cărții de identitate.',
    'contract.selectSocialBenefits': 'Selectați o opțiune pentru prestații sociale.',
    'contract.uploadWorkPermit': 'Încărcați documentul permisului de muncă.',
    'contract.signFirst': 'Semnați contractul înainte de trimitere.',
    'contract.saveError': 'Eroare la salvarea contractului',
    'contract.submitError': 'Eroare la trimiterea contractului',
    'contract.fillPrevJobs': 'Vă rugăm să introduceți un loc de muncă anterior sau să bifați "fără angajare pe termen scurt în 2026".',
    'contract.prevJobsIncomplete': 'Vă rugăm să completați INTEGRAL angajarea pe termen scurt (de la, până la, total zile, angajator) – sau ștergeți rândul ori bifați "fără angajare pe termen scurt".',
    'contract.loadTemplateError': 'Eroare la încărcarea șablonului',
    'contract.reqName': 'Numele angajatului',
    'contract.reqAddress': 'Adresa angajatului',
    'contract.reqStreet': 'Stradă',
    'contract.reqPLZ': 'Cod poștal',
    'contract.reqCity': 'Oraș',
    'contract.reqBirthdate': 'Data nașterii',
    'contract.reqNationality': 'Cetățenia',
    'contract.reqSocialSec': 'Numărul asigurării sociale',
    'contract.reqBirthPlace': 'Locul nașterii',
    'contract.reqTaxId': 'Codul de identificare fiscală',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Locul (înainte de semnătură)',
    'contract.pdfLanguageNotice': 'Notă: Contractul PDF va fi creat în limba germană.',
    'contract.pdfTranslationNotice': 'Notă: Contractul PDF va fi creat în limba engleză.',
  },

  // ==================== УКРАЇНСЬКА ====================
  uk: {
    'lug.title': 'Знайдіть свій багаж',
    'lug.subtitle': 'Знайдіть свій багаж',
    'lug.searchHint': 'Введіть номер квитка, щоб знайти правильну станцію видачі',
    'lug.ticketLabel': 'Номер квитка',
    'lug.ticketPh': 'напр. 1234 або 5678',
    'lug.ticketRange': 'Номери від 1 до 12000',
    'lug.findStation': 'Знайти станцію',
    'lug.notFoundTitle': 'Станцію не знайдено',
    'lug.notFoundText': 'Для цього номера квитка не вдалося знайти багажну станцію. Будь ласка, перевірте номер.',
    'lug.pickupStation': 'Ваша станція видачі',
    'lug.openMaps': 'Відкрити Google Maps',
    'lug.cantPickup': 'Не можете забрати? Замовте доставку',
    'lug.shippingRequest': 'Запит на доставку',
    'lug.personalData': 'Особисті дані',
    'lug.fullName': "Повне ім'я",
    'lug.emailLabel': 'Електронна пошта',
    'lug.phoneLabel': 'Телефон',
    'lug.address': 'Адреса',
    'lug.postalCode': 'Поштовий індекс',
    'lug.city': 'Місто',
    'lug.country': 'Країна',
    'lug.requiredDocs': 'Необхідні документи',
    'lug.ticketPhoto': 'Фото квитка',
    'lug.ticketPhotoHint': 'Фото або PDF вашого квитка',
    'lug.dhlLabel': 'Транспортна етикетка DHL',
    'lug.dhlBuyHint': 'Вам потрібно придбати етикетку DHL:',
    'lug.dhlBuy': 'Придбати етикетку DHL',
    'lug.dhlImportant': 'Важливо: переконайтеся, що вибрали правильний розмір і вагу для вашого багажу!',
    'lug.send': 'Надіслати запит на доставку',
    'lug.sending': 'Надсилання...',
    'lug.cancel': 'Скасувати',
    'lug.successMsg': 'Запит на доставку успішно надіслано! Ви отримаєте лист-підтвердження.',
    'lug.refLabel': 'Ваш номер заявки:',
    'lug.confirmMail': 'Підтвердження буде надіслано на:',
    'lug.errRequired': "Будь ласка, заповніть усі обов'язкові поля.",
    'lug.errSend': 'Помилка під час надсилання запиту',
    'lug.back': 'Назад на головну',
    'reg.title': 'Заявка',
    'reg.subtitle': 'Планування персоналу Oktoberfest',
    'reg.onlyTitle': 'Тільки для кандидатів!',
    'reg.onlyText': 'Ця форма призначена виключно для подання заявки як співробітник. Для послуги інвалідних візків або пошуку багажу скористайтеся посиланнями на головній сторінці.',
    'reg.homepage': 'головна сторінка',
    'reg.firstname': "Ім'я",
    'reg.firstnamePh': "Ваше ім'я",
    'reg.lastname': 'Прізвище',
    'reg.lastnamePh': 'Ваше прізвище',
    'reg.birthdate': 'Дата народження',
    'reg.birthdateHint': 'Також слугує паролем для входу',
    'reg.phone': 'Номер телефону',
    'reg.optional': "(необов'язково)",
    'reg.email': 'Електронна пошта',
    'reg.emailOptional': "(необов'язково, для підтвердження)",
    'reg.submit': 'Подати заявку',
    'reg.submitting': 'Реєстрація...',
    'reg.alreadyReg': 'Вже зареєстровані?',
    'reg.toLogin': 'До входу',
    'reg.successTitle': 'Реєстрація успішна!',
    'reg.successText': 'Ваш обліковий запис створено. Тепер ви можете увійти за прізвищем та датою народження.',
    'reg.errFirstname': "Будь ласка, введіть ім'я",
    'reg.errLastname': 'Будь ласка, введіть прізвище',
    'reg.errBirthdate': 'Будь ласка, введіть дату народження (ДД.ММ.РРРР)',
    'reg.errDateFormat': 'Невірний формат дати',
    'reg.errFailed': 'Реєстрація не вдалася. Спробуйте ще раз.',
    'tab.overview': 'Огляд',
    'tab.users': 'Працівники',
    'tab.personalPlanning': 'Призначення Змін',
    'tab.flexibleShifts': 'Планування Потреб',
    'tab.tasksAndPlanning': 'Завдання і Планування',
    'tab.availability': 'Доступність',
    'tab.documents': 'Документи',
    'tab.actualHours': 'Фактичні Години',
    'tab.reports': 'Зміни',
    'tab.luggageShipping': 'Відправлення Багажу',
    'tab.wheelchairAdmin': 'Інвалідні\nВізки',
    'tab.backups': 'Резервні копії',

    'nav.brand': 'Oktoberfest Планування Персоналу',
    'nav.profile': 'Профіль',
    'nav.logout': 'Вийти',
    'nav.user': 'Користувач',
    'nav.language': 'Мова',

    'approval.title': 'Очікування активації',
    'approval.description': 'Ваш обліковий запис створено, але його має активувати адміністратор, перш ніж ви зможете використовувати управління візками.',
    'approval.badge': 'Ще не активовано',

    'overview.title': 'Огляд',
    'overview.welcome': 'Ласкаво просимо, {name}!',
    'overview.myShiftsToday': 'Мої зміни сьогодні ({date})',
    'overview.planningDraftTitle': '🚧 Графік змін ще в роботі!',
    'overview.planningDraftText': 'Те, що ви бачите тут, ще НЕ остаточне – час може змінитися, і не всі дні заплановані. Не хвилюйтеся! Щойно ваш графік буде остаточним, ви автоматично отримаєте повідомлення у WhatsApp. 📲',
    'overview.currentShifts': 'Поточні Зміни',
    'overview.loading': 'Завантаження...',
    'overview.loadingShifts': 'Завантаження сьогоднішніх змін...',
    'overview.time': 'Час',
    'overview.station': 'Станція',
    'overview.status': 'Статус',
    'overview.planned': 'Заплановано',
    'overview.noShifts': 'У вас немає запланованих змін сьогодні.',
    'overview.freeDay': 'Насолоджуйтеся вихідним! 🎉',
    'overview.notifications': 'Сповіщення',
    'overview.noNotifications': 'Немає нових сповіщень',

    'day.sunday': 'Неділя', 'day.monday': 'Понеділок', 'day.tuesday': 'Вівторок',
    'day.wednesday': 'Середа', 'day.thursday': 'Четвер', 'day.friday': "П'ятниця", 'day.saturday': 'Субота',

    'avail.title': 'Доступність Працівників',
    'avail.add': 'Додати Доступність',
    'avail.filter': 'Фільтр',
    'avail.allEmployees': 'Всі Працівники',
    'avail.onlyYours': 'Ви можете керувати лише власною доступністю',
    'avail.available': 'Доступний',
    'avail.notAvailable': 'Недоступний',
    'avail.mixed': 'Змішано',
    'avail.selected': 'Обрано',
    'avail.noEntry': 'Немає запису',
    'avail.weekday': 'День',
    'avail.notes': 'Примітки',
    'avail.actions': 'Дії',
    'avail.noData': 'Немає записів доступності',
    'avail.flexible': 'Гнучкий',
    'avail.morning': 'Ранок',
    'avail.midday': 'Обід',
    'avail.evening': 'Вечір',
    'avail.custom': 'Інше',
    'avail.saved': 'Доступність збережено успішно!',
    'avail.deleted': 'Доступність видалено успішно',
    'avail.confirmDelete': 'Справді видалити цю доступність?',
    'avail.save': 'Зберегти', 'avail.cancel': 'Скасувати', 'avail.delete': 'Видалити',
    'avail.fromDate': 'Від дати', 'avail.toDate': 'До дати',
    'avail.hintFillAll': 'Будь ласка, заповніть щось на кожен день, навіть якщо недоступні. Це допомагає при плануванні.',
    'avail.shortAvailWarning': 'При такій короткій доступності (3 години або менше) фактичне призначення стає менш імовірним.',
    'avail.hintOnlyAvail': 'Тут ви вказуєте лише свою доступність – ваш фактичний робочий час буде заплановано з цього часового вікна.',
    'avail.existingEntries': 'Існуючі записи',
    'avail.replaceExisting': 'Замінити наявні записи',
    'avail.replaceExistingHint': 'рекомендовано – старі години на цей день буде видалено',
    'avail.addWindow': 'Додати додатковий проміжок часу',
    'avail.addWindowHint': 'напр. доступний вранці ТА ввечері, але не між ними',
    'avail.newestEntry': 'останній запис',
    'avail.olderEntry': 'старіший запис',
    'avail.fullDayFlex': 'Весь день (гнучко)',
    'avail.noteOptional': 'Нотатка (необов’язково)',
    'avail.alsoApplyTo': 'Також застосувати до:',
    'avail.deselect': 'Зняти вибір',
    'avail.additionalDays': '{count} додаткових днів вибрано',
    'avail.daysHaveEntries': '{count} з вибраних днів уже мають записи',
    'avail.willReplace': 'їх буде замінено',
    'avail.willAdd': 'новий проміжок часу буде додано додатково',
    'avail.switchMode': 'перемкнути',
    'avail.update': 'Оновити',
    'avail.days': 'днів',
    'avail.allDays': 'Всі',
    'avail.filterFirst': 'Будь ласка, спочатку виберіть працівника вище.',
    'avail.calendarView': 'Календарний вид',
    'avail.clickDate': 'Натисніть на дату, щоб редагувати доступність',
    'avail.showingFor': 'Показано для:',
    'avail.withoutAvailFor': 'Без доступності:',
    'avail.adminFilterFirst': 'Будь ласка, спочатку виберіть працівника, щоб внести доступність.',
    'avail.notePlaceholder': 'напр. лише за потреби, лікар о 15...',
    'avail.legendGreen': 'Зелений',
    'avail.legendRed': 'Червоний',
    'avail.legendYellow': 'Жовтий',
    'avail.legendBlue': 'Синій',
    'avail.legendGray': 'Сірий',
    'avail.progress': 'Прогрес',
    'avail.statsAvail': 'доступний',
    'avail.statsNotAvail': 'недоступний',
    'avail.statsOpen': 'відкрито',

    // Partner
    'partner.title': 'Партнерська команда',
    'partner.myCode': 'Мій код партнера',
    'partner.copy': 'Копіювати код',
    'partner.regenerate': 'Створити новий код',
    'partner.shareHint': 'Поділіться цим кодом з колегами, з якими хочете працювати.',
    'partner.addByCode': 'Додати партнера',
    'partner.link': 'Пов’язати',
    'partner.linked': 'Партнер успішно пов’язаний!',
    'partner.unlinked': 'Зв’язок видалено.',
    'partner.codeRegenerated': 'Новий код партнера створено.',
    'partner.myPartners': 'Мої партнери',
    'partner.noPartners': 'Ще немає пов’язаних партнерів. Поділіться кодом з колегами!',
    'partner.noEntry': 'Немає запису на цей день',
    'partner.noAccess': 'Немає доступу',
    'partner.visibilityLabel': 'Мої партнери можуть бачити мій робочий час',
    'partner.visibilityHint': 'Коли увімкнено, ваші партнери бачать вашу доступність в огляді.',
    'partner.shareNumberLabel': 'Мої партнери можуть бачити мій номер телефону',
    'partner.shareNumberHint': 'Якщо увімкнено, ваш номер телефону може бути доступний повʼязаним партнерам (наприклад, для звʼязку у WhatsApp).',
    'partner.visibilityOn': 'Видимість увімкнена',
    'partner.visibilityOff': 'Видимість вимкнена',
    'partner.overview': 'Огляд партнерів',
    'partner.overviewHint': 'Показані лише партнери з увімкненою видимістю. Лише для читання.',
    'partner.refresh': 'Оновити',

    'doc.title': 'Управління Документами',
    'doc.tabMyDocs': 'Мої Документи',
    'doc.tabMyContract': 'Мій Трудовий Договір',
    'doc.noDocuments': 'Документів немає',
    'doc.typeContract': 'Трудовий Договір',
    'doc.typePayslip': 'Розрахунковий Лист',
    'doc.typeResidencePermit': 'Посвідка на Проживання',
    'doc.typeWorkPermit': 'Дозвіл на Роботу',
    'doc.typeOther': 'Інше',
    'doc.statusPending': 'Очікується',
    'doc.statusApproved': 'Затверджено',
    'doc.statusRejected': 'Відхилено',

    'reports.title': 'Години Змін {year}',
    'reports.loading': 'Завантаження...',
    'reports.selectYear': 'Оберіть рік:',
    'reports.tabShifts': 'Заплановані Зміни',
    'reports.tabTimes': 'Фактичний Час',
    'reports.hourConfirmation': 'Підтвердження Годин',
    'reports.exportCalendar': 'Експорт Календаря',

    'wc.title': '🦽 Управління Інвалідними Візками',
    'wc.refresh': 'Оновити', 'wc.retry': 'Спробувати знову',
    'wc.totalBookings': 'Всього Бронювань', 'wc.today': 'Сьогодні',
    'wc.wheelchairs': 'Візки', 'wc.stations': 'Станції',
    'wc.filter': 'Фільтр', 'wc.fromDate': 'Від', 'wc.toDate': 'До',
    'wc.resetFilter': 'Скинути Фільтр',
    'wc.bookings': 'Бронювання ({count})',
    'wc.noBookings': 'Бронювань не знайдено',
    'wc.wheelchairNum': 'Візок {num}',
    'wc.save': 'Зберегти', 'wc.cancelEdit': 'Скасувати', 'wc.edit': 'Редагувати', 'wc.delete': 'Видалити',
    'wc.confirmDelete': 'Справді видалити це бронювання?',
    'wc.loadingData': 'Завантаження...', 'wc.loadError': 'Помилка завантаження даних',
    'wc.noBookingsForPeriod': 'Немає бронювань за обраний період.',

    'wr.title': '🦽 Оренда Інвалідних Візків Oktoberfest {year}',
    'wr.hours': 'Графік роботи під час Oktoberfest:',
    'wr.period': 'Період доступності: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Оберіть день',
    'wr.step2': '2. Оберіть час',
    'wr.step3': '3. Оберіть станцію та візок',
    'wr.startTime': 'Початок:', 'wr.selectStart': 'Оберіть час початку',
    'wr.endTime': 'Кінець:', 'wr.selectEnd': 'Оберіть час кінця',
    'wr.name': "Ім'я (обов'язково):", 'wr.namePlaceholder': "Повне ім'я",
    'wr.emailLbl': 'Електронна пошта (необов’язково):',
    'wr.phoneLbl': 'Телефон (за бажанням):', 'wr.phonePlaceholder': 'Номер телефону',
    'wr.remarksLbl': 'Примітки (за бажанням):', 'wr.remarksPlaceholder': 'Додаткові примітки',
    'wr.bookNow': 'Забронювати', 'wr.booking': 'Бронювання...',
    'wr.bookingSuccess': '✅ Бронювання успішне!',
    'wr.bookingSuccessMsg': 'Бронювання на {date} успішне!',
    'wr.newBooking': 'Нове Бронювання',
    'wr.copyDetails': '📋 Копіювати деталі',
    'wr.copied': 'Деталі скопійовано!',
    'wr.noWheelchairs': 'Немає доступних візків на цей період.',
    'wr.chooseOtherTimes': 'Будь ласка, виберіть інший час.',
    'wr.unknownStation': 'Невідома станція',
    'wr.clock': '',
    'wr.backToLogin': 'Повернутися до входу',
    'day.sunShort': 'Нд', 'day.monShort': 'Пн', 'day.tueShort': 'Вт',
    'day.wedShort': 'Ср', 'day.thuShort': 'Чт', 'day.friShort': 'Пт', 'day.satShort': 'Сб',

    // Contract Form
    'contract.title': 'Цифровий Трудовий Договір',
    'contract.loadTemplate': 'Завантажити мій шаблон',
    'contract.saving': 'Збереження...',
    'contract.save': 'Зберегти',
    'contract.cancel': 'Скасувати',
    'contract.edit': 'Редагувати',
    'contract.editContract': 'Редагувати договір',
    'contract.fillContract': 'Заповнити договір',
    'contract.printPdf': 'Друк як PDF',
    'contract.contractHeading': 'Договір про Короткострокове Працевлаштування',
    'contract.between': 'Між',
    'contract.and': 'та',
    'contract.employeeLabel': 'Працівник:',
    'contract.nameLabel': "Прізвище, Ім'я:",
    'contract.namePlaceholder': "Прізвище, Ім'я",
    'contract.toBeFilled': '[Заповнити]',
    'contract.address': 'проживає:',
    'contract.addressPlaceholder': '(Вулиця, Номер, Поштовий індекс, Місто)',
    'contract.street': 'Вулиця',
    'contract.streetPlaceholder': 'вул. Прикладна',
    'contract.houseNr': '№',
    'contract.houseNrPlaceholder': '12а',
    'contract.plz': 'Індекс',
    'contract.plzPlaceholder': '80331',
    'contract.city': 'Місто',
    'contract.cityPlaceholder': 'Мюнхен',
    'contract.birthdate': 'Дата народження:',
    'contract.nationality': 'Громадянство:',
    'contract.pleaseSelect': 'Будь ласка, оберіть...',
    'contract.workPermitRequired': 'Потрібен дозвіл на роботу',
    'contract.socialSecNr': 'Номер соціального страхування:',
    'contract.birthPlace': 'Місце народження (Місто):',
    'contract.taxId': 'Податковий ідентифікаційний номер:',
    'contract.socialBenefits': 'Соціальні виплати:',
    'contract.selectOption': 'Оберіть варіант',
    'contract.basicSecurity': 'Я отримую базове забезпечення',
    'contract.unemployment': 'Я отримую допомогу по безробіттю',
    'contract.pension': 'Я отримую пенсію',
    'contract.noBenefits': 'Я не отримую жодного з вищезгаданих',
    'contract.notFilled': '[Не заповнено]',
    'contract.idCard': 'Посвідчення особи (передня сторона)',
    'contract.idUploaded': 'Посвідчення завантажено',
    'contract.remove': 'Видалити',
    'contract.fileTooLarge': 'Файл занадто великий. Максимум 10 МБ.',
    'contract.idUploadHelper': "Завантажте фото передньої сторони посвідчення. (Обов'язково, макс. 10 МБ)",
    'contract.notUploaded': '[Не завантажено]',
    'contract.iban': 'IBAN:',
    'contract.altAccountHolder': 'Інший власник рахунку (якщо є):',
    'contract.residencePermit': 'Дозвіл на проживання / Дозвіл на роботу',
    'contract.nonEuNotice': 'Оскільки ви вказали громадянство не з ЄС, потрібен документ дозволу на роботу.',
    'contract.docUploaded': 'Документ завантажено',
    'contract.prevJobs': 'Попередні короткострокові працевлаштування у 2026',
    'contract.noPrevJobs': 'Немає короткострокового працевлаштування у 2026.',
    'contract.noPrevJobsCheck': 'немає короткострокового працевлаштування у 2026',
    'contract.from': 'Від:',
    'contract.to': 'До:',
    'contract.totalDays': 'Всього днів:',
    'contract.employer': 'Роботодавець',
    'contract.actions': 'Дії',
    'contract.addJob': 'Додати ще одне працевлаштування',
    'contract.placeDate': 'Місце, Дата:',
    'contract.placePlaceholder': 'Введіть місце *',
    'contract.signedOn': 'Підписано:',
    'contract.notSigned': 'Ще не підписано',
    'contract.employeeSignature': 'Підпис працівника',
    'contract.signDigitally': 'Підписати цифрово',
    'contract.uploadImage': 'Завантажити зображення',
    'contract.deleteSignature': 'Видалити',
    'contract.employerSignature': 'Підпис роботодавця',
    'contract.parentSignature': 'Підпис опікуна',
    'contract.parentNote': '(якщо неповнолітній)',
    'contract.finalize': 'Завершити договір',
    'contract.finalizeHint': 'Перевірте всі дані та надішліть договір.',
    'contract.templateOptions': 'Опції шаблону',
    'contract.templateOptionsHint': 'Бажаєте зберегти дані як шаблон?',
    'contract.noTemplate': 'Ні, продовжити без шаблону',
    'contract.yesTemplate': 'Так, зберегти як шаблон',
    'contract.deleteTemplateOption': 'Видалити існуючий шаблон',
    'contract.submitting': 'Надсилається...',
    'contract.submit': 'Надіслати договір',
    'contract.back': 'Назад',
    'contract.saveDraft': 'Зберегти як чернетку',
    'contract.myContracts': 'Мої Договори',
    'contract.hide': 'Сховати',
    'contract.show': 'Показати',
    'contract.noContracts': 'Договорів ще немає',
    'contract.digitalSignature': 'Цифровий Підпис',
    'contract.signatureHint': 'Підпишіть мишкою або пальцем нижче:',
    'contract.restart': 'Почати заново',
    'contract.acceptSignature': 'Прийняти підпис',
    'contract.fillRequired': "Заповніть обов'язкові поля:",
    'contract.uploadIdCard': 'Завантажте фото посвідчення особи.',
    'contract.selectSocialBenefits': 'Оберіть варіант соціальних виплат.',
    'contract.uploadWorkPermit': 'Завантажте документ дозволу на роботу.',
    'contract.signFirst': 'Підпишіть договір перед надсиланням.',
    'contract.saveError': 'Помилка збереження договору',
    'contract.submitError': 'Помилка надсилання договору',
    'contract.fillPrevJobs': 'Будь ласка, введіть попереднє короткострокове працевлаштування або позначте "без короткострокового працевлаштування у 2026".',
    'contract.prevJobsIncomplete': 'Будь ласка, заповніть короткострокове працевлаштування ПОВНІСТЮ (з, до, всього днів, роботодавець) – або видаліть рядок чи позначте "без короткострокового працевлаштування".',
    'contract.loadTemplateError': 'Помилка завантаження шаблону',
    'contract.reqName': "Ім'я працівника",
    'contract.reqAddress': 'Адреса працівника',
    'contract.reqStreet': 'Вулиця',
    'contract.reqPLZ': 'Поштовий індекс',
    'contract.reqCity': 'Місто',
    'contract.reqBirthdate': 'Дата народження',
    'contract.reqNationality': 'Громадянство',
    'contract.reqSocialSec': 'Номер соціального страхування',
    'contract.reqBirthPlace': 'Місце народження',
    'contract.reqTaxId': 'Податковий ID',
    'contract.reqIban': 'IBAN',
    'contract.reqPlace': 'Місце (перед підписом)',
    'contract.pdfLanguageNotice': 'Примітка: Договір PDF буде створений німецькою мовою.',
    'contract.pdfTranslationNotice': 'Примітка: Договір PDF буде створений англійською мовою.',
  },

  // ==================== BOARISCH ====================
  bar: {
    'lug.title': 'Gepäck suacha',
    'lug.subtitle': 'Find dei Gepäck',
    'lug.searchHint': 'Gib dei Ticketnummer ei, damit ma de richtige Abholstation findt',
    'lug.ticketLabel': 'Ticket-Nummer',
    'lug.ticketPh': 'z.B. 1234 oder 5678',
    'lug.ticketRange': 'Nummern vo 1 bis 12000',
    'lug.findStation': 'Station finna',
    'lug.notFoundTitle': 'Koa Station gfunna',
    'lug.notFoundText': 'Zu dera Ticketnummer hod ma koa Gepäckstation zuordna kenna. Schau bittschön d’Nummer no amoi o.',
    'lug.pickupStation': 'Dei Abholstation',
    'lug.openMaps': 'Google Maps aufmacha',
    'lug.cantPickup': 'Kannst ned abhoin? Versand obfrang',
    'lug.shippingRequest': 'Versandobfrang',
    'lug.personalData': 'Persönliche Datn',
    'lug.fullName': 'Ganzer Nam',
    'lug.emailLabel': 'E-Mail',
    'lug.phoneLabel': 'Telefon',
    'lug.address': 'Adress',
    'lug.postalCode': 'PLZ',
    'lug.city': 'Stod',
    'lug.country': 'Land',
    'lug.requiredDocs': 'Notwendige Unterlagn',
    'lug.ticketPhoto': 'Ticket-Foto',
    'lug.ticketPhotoHint': 'Foto oder PDF vo deim Ticket',
    'lug.dhlLabel': 'DHL Versandlabel',
    'lug.dhlBuyHint': 'Du muasst a DHL-Label kaffa:',
    'lug.dhlBuy': 'DHL Label kaffa',
    'lug.dhlImportant': 'Wichtig: Schau auf de richtige Größn und s’Gwicht für dei Gepäck!',
    'lug.send': 'Versandobfrang schicka',
    'lug.sending': 'Werd gschickt...',
    'lug.cancel': 'Obbrecha',
    'lug.successMsg': 'Versandobfrang is guat oganga! Du kriagst a Bestätigungs-E-Mail.',
    'lug.refLabel': 'Dei Referenznummer:',
    'lug.confirmMail': 'Bestätigung geht an:',
    'lug.errRequired': 'Bittschön fui olle Pflichtfelder aus.',
    'lug.errSend': 'Fehler beim Schicka vo da Obfrang',
    'lug.back': 'Zruck zua Startseitn',
    'reg.title': 'Bewerbung',
    'reg.subtitle': 'Oktoberfest Personalplanung',
    'reg.onlyTitle': 'Nur für Bewerber!',
    'reg.onlyText': 'Des Formular is bloß für d’Bewerbung als Mitarbeiter/in. Fürn Rollstuhlservice oder d’Gepäcksuach bittschön d’Links af da Startseitn nehma.',
    'reg.homepage': 'Startseitn',
    'reg.firstname': 'Vurnam',
    'reg.firstnamePh': 'Dei Vurnam',
    'reg.lastname': 'Nachnam',
    'reg.lastnamePh': 'Dei Nachnam',
    'reg.birthdate': 'Geburtsdatum',
    'reg.birthdateHint': 'Is gleichzeiti dei Passwort zum Anmeldn',
    'reg.phone': 'Telefonnummer',
    'reg.optional': '(freiwilli)',
    'reg.email': 'E-Mail',
    'reg.emailOptional': '(freiwilli, für d’Bestätigung)',
    'reg.submit': 'Etz bewerba',
    'reg.submitting': 'Werd gschpeichert...',
    'reg.alreadyReg': 'Scho registriert?',
    'reg.toLogin': 'Zum Anmeldn',
    'reg.successTitle': 'Registrierung hod kappt!',
    'reg.successText': 'Dei Konto is anglegt. Du kannst di etz mit Nachnam und Geburtsdatum anmeldn.',
    'reg.errFirstname': 'Bittschön gib dein Vurnam ei',
    'reg.errLastname': 'Bittschön gib dein Nachnam ei',
    'reg.errBirthdate': 'Bittschön gib dei Geburtsdatum ei (TT.MM.JJJJ)',
    'reg.errDateFormat': 'Ungültigs Datumsformat',
    'reg.errFailed': 'Registrierung hod ned kappt. Probier’s no amoi.',
    'tab.overview': 'Übersicht',
    'tab.users': 'Leidl',
    'tab.personalPlanning': 'Schicht-Zuadeilung',
    'tab.flexibleShifts': 'Bedarfs-Planung',
    'tab.tasksAndPlanning': 'Aufgab\'n und Planung',
    'tab.availability': 'Wann ko i?',
    'tab.documents': 'Papierl',
    'tab.actualHours': 'Echte Stund\'n',
    'tab.reports': 'Einsatz',
    'tab.luggageShipping': 'Gepäck-Versand',
    'tab.wheelchairAdmin': 'Rollstuihl-\nVerleih',
    'tab.backups': 'Sicherungen',

    'nav.brand': 'Wiesn Personalplanung',
    'nav.profile': 'Mei Profil',
    'nav.logout': 'Aufhör\'n',
    'nav.user': 'Benutzer',
    'nav.language': 'Sproch',

    'approval.title': 'Woart no auf\'d Freischaltung',
    'approval.description': 'Dei Konto is ang\'legt, aba da Chef muass di erst no freischalt\'n, bevors\'d as Rollstuihl-Ding nutz\'n kannst.',
    'approval.badge': 'No ned freig\'schalt\'t',

    'overview.title': 'Übersicht',
    'overview.welcome': 'Servus {name}!',
    'overview.myShiftsToday': 'Mei Schicht\'n heid ({date})',
    'overview.planningDraftTitle': '🚧 Dienstplan is no ned fertig!',
    'overview.planningDraftText': 'Wos du do siehgst, is no NED fix – Zeidn kenna se no ändern und no ned olle Dog san verplant. Oiso ned wundern! Sobald dei Dienstplan steht, kriagst automatisch a WhatsApp vo uns. 📲',
    'overview.currentShifts': 'Aktuelle Schicht\'n',
    'overview.loading': 'Lad\'t...',
    'overview.loadingShifts': 'Dei Schicht\'n wer\'n g\'lad\'n...',
    'overview.time': 'Zeit',
    'overview.station': 'Station',
    'overview.status': 'Status',
    'overview.planned': 'Geplant',
    'overview.noShifts': 'Heid hast koane Schicht\'n.',
    'overview.freeDay': 'Genieß dein\'n freien Tag! 🍻',
    'overview.adminPlaceholder': 'Do wer\'n de aktuellen Schicht\'n anzeigt...',
    'overview.notifications': 'Nachrichten',
    'overview.noNotifications': 'Nix Neues',

    'day.sunday': 'Sunndog', 'day.monday': 'Mondog', 'day.tuesday': 'Iada',
    'day.wednesday': 'Migga', 'day.thursday': 'Pfinsdog', 'day.friday': 'Freidog', 'day.saturday': 'Somsdog',

    'avail.title': 'Wann konnst du?',
    'avail.add': 'Dazua toa',
    'avail.filter': 'Filt\'a',
    'avail.allEmployees': 'Alle Leidl',
    'avail.onlyYours': 'Du konnst nua dei eigane Verfügbarkeit ändern',
    'avail.available': 'Ko i',
    'avail.notAvailable': 'Ko i ned',
    'avail.mixed': 'Gemischt',
    'avail.selected': 'Ausg\'wählt',
    'avail.noEntry': 'Nix eing\'trag\'n',
    'avail.weekday': 'Wochentog',
    'avail.notes': 'Notiz\'n',
    'avail.actions': 'Was toa?',
    'avail.noData': 'No nix eing\'trag\'n',
    'avail.pleaseEnter': 'Bittschön trag dei Verfügbarkeit ei',
    'avail.flexible': 'Flexibel',
    'avail.morning': 'In da Fruah',
    'avail.midday': 'Mittogs',
    'avail.evening': 'Auf d\'Nacht',
    'avail.custom': 'Wia i mog',
    'avail.editModal': 'Verfügbarkeit änd\'an',
    'avail.newModal': 'Neie Verfügbarkeit',
    'avail.multiDays': 'Mehrane Tog auf amoi',
    'avail.type': 'Art',
    'avail.saved': 'Basst! Is g\'speichert!',
    'avail.deleted': 'Is weg!',
    'avail.confirmDelete': 'Wirkli lösch\'n?',
    'avail.flexTime': '⏰ 07:00 - 01:00 (nächster Tog)',
    'avail.morningTime': '🌅 07:00 - 14:00',
    'avail.middayTime': '☀️ 11:00 - 18:00',
    'avail.eveningTime': '🌙 18:00 - 01:00 (nächster Tog)',
    'avail.customTime': '✏️ Eigane Zeit\'n',
    'avail.save': 'Speich\'an',
    'avail.cancel': 'Doch ned',
    'avail.delete': 'Weg damit',
    'avail.fromDate': 'Vo wann', 'avail.toDate': 'Bis wann',
    'avail.hintFillAll': 'Bitte für jedn Tog wos eintrog\'n, aa wenn ned do bist. Des hilft beim Plana.',
    'avail.shortAvailWarning': 'Bei so wenig Zeit (3 Stund oder weniga) is a Einsatz eher ned drin.',
    'avail.hintOnlyAvail': 'Do gibst nur dei Verfügbarkeit o – dei echte Arbeitszeit wird aus dem Zeitfenster plant.',
    'avail.existingEntries': 'Wos scho do is',
    'avail.replaceExisting': 'De oidn Eintragungen ersetzn',
    'avail.replaceExistingHint': 'empfohlen – de oidn Zeidn fia den Dog wern glöscht',
    'avail.addWindow': 'No a Zeitfenster dazua',
    'avail.addWindowHint': 'z. B. vormittogs UND obnds do, dazwischn ned',
    'avail.newestEntry': 'zletzt eitragn',
    'avail.olderEntry': 'öiterer Eintrog',
    'avail.fullDayFlex': 'Gonzer Tog (flexibel)',
    'avail.noteOptional': 'Notiz (wenn\'d mogst)',
    'avail.alsoApplyTo': 'Aa für de Tog:',
    'avail.deselect': 'Nix davon',
    'avail.additionalDays': '{count} Tog/Tage no dazua',
    'avail.daysHaveEntries': '{count} vo de gwöihtn Dog ham scho wos drin',
    'avail.willReplace': 'de wern ersetzt',
    'avail.willAdd': 'as neie Zeitfenster kimmt no dazua',
    'avail.switchMode': 'umschoitn',
    'avail.update': 'Aktualisier\'n',
    'avail.days': 'Tog',
    'avail.allDays': 'Olle',
    'avail.filterFirst': 'Bitte zuerscht obn an Mitarbeita auswähl\'n.',
    'avail.calendarView': 'Kalenda-Ansicht',
    'avail.clickDate': 'Druck auf a Datum zum Bearbeitn',
    'avail.showingFor': 'Anzeig nur fia:',
    'avail.withoutAvailFor': 'Ohne Verfügbarkeit:',
    'avail.adminFilterFirst': 'Bitte zuerscht obn an Mitarbeita auswähl\'n, um Verfügbarkeitn einzutrag\'n.',
    'avail.notePlaceholder': 'z.B. nur wenns sei muass, Doktor ab 15 Uhr...',
    'avail.legendGreen': 'Grean',
    'avail.legendRed': 'Rot',
    'avail.legendYellow': 'Gelb',
    'avail.legendBlue': 'Blau',
    'avail.legendGray': 'Grau',
    'avail.progress': 'Fortschritt',
    'avail.statsAvail': 'verfügbar',
    'avail.statsNotAvail': 'ned verfügbar',
    'avail.statsOpen': 'offen',

    // Partner
    'partner.title': 'Partner-Teamal',
    'partner.myCode': 'Mei Partnercode',
    'partner.copy': 'Code kopier\'n',
    'partner.regenerate': 'Neia Code moch\'n',
    'partner.shareHint': 'Gib den Code an Leit weida, mit dene du gern schaffst.',
    'partner.addByCode': 'Partner dazua doa',
    'partner.link': 'Verknüpf\'n',
    'partner.linked': 'Partner is jetzad verknüpft!',
    'partner.unlinked': 'Verknüpfung aufg\'hob\'n.',
    'partner.codeRegenerated': 'Neia Code is do.',
    'partner.myPartners': 'Mei Partner',
    'partner.noPartners': 'No koa Partner verknüpft. Gib dein Code weida!',
    'partner.noEntry': 'Nix eintrog\'n für den Tog',
    'partner.noAccess': 'Koa Zugriff',
    'partner.visibilityLabel': 'Meine Partna deafn meine Arbeitszeit seng',
    'partner.visibilityHint': 'Wenns aktiv is, kenna deine Partna dei Verfügbarkeit in da Übersicht seng.',
    'partner.shareNumberLabel': 'Meine Partna derfa mei Handynummer seng',
    'partner.shareNumberHint': 'Wenns aktiv is, ko dei Handynummer mit deine verbundenen Partna teilt wern (z.B. zum Ausmacha per WhatsApp).',
    'partner.visibilityOn': 'Sichtbarkeit aktiviert',
    'partner.visibilityOff': 'Sichtbarkeit deaktiviert',
    'partner.overview': 'Partna-Übersicht',
    'partner.overviewHint': 'Nur Partna mit aktivierter Sichtbarkeit wern anzeigt. Nur lesen.',
    'partner.refresh': 'Aktualisier\'n',

    'doc.title': 'Papierl-Verwaltung',
    'doc.upload': 'Papierl hochlad\'n',
    'doc.select': 'Auswähl\'n...',
    'doc.docType': 'Was für a Papierl',
    'doc.selectFile': 'Datei auswähl\'n *',
    'doc.uploading': 'Lad\'t hoch...',
    'doc.uploadBtn': 'Hochlad\'n',
    'doc.overview': 'Papierl-Übersicht',
    'doc.noDocuments': 'Koane Papierl do',
    'doc.tabMyDocs': 'Mei Papierl',
    'doc.tabMyContract': 'Mei Arbeitsvertrag',
    'doc.filename': 'Dateinam',
    'doc.type': 'Art', 'doc.status': 'Status', 'doc.date': 'Datum', 'doc.actions': 'Was toa?',
    'doc.view': 'Anschau\'n', 'doc.deleteBtn': 'Weg damit',
    'doc.statusPending': 'Wart\'t no',
    'doc.statusApproved': 'Basst!',
    'doc.statusRejected': 'Abg\'lehnt',
    'doc.typeContract': 'Arbeitsvertrag',
    'doc.typeAvailability': 'Verfügbarkeit',
    'doc.typePayslip': 'Lohnabrech\'ung',
    'doc.typeResidencePermit': 'Aufenthaltstitl',
    'doc.typeWorkPermit': 'Arbeitsgenehmigung',
    'doc.typeOther': 'Sonstigs',

    'reports.title': 'Einsatzzeitn {year}',
    'reports.loading': 'Lad\'t...',
    'reports.loadingYear': 'Lad Einsatzzeitn fia {year}...',
    'reports.selectYear': 'Johr auswähl\'n:',
    'reports.tabShifts': 'Geplante Schicht\'n',
    'reports.tabTimes': 'Echte Zeit\'n',
    'reports.hourConfirmation': 'Stund\'n bestätig\'n',
    'reports.exportCalendar': 'Kalenda exportier\'n',

    'wc.title': '🦽 Rollstuihl-Verwaltung',
    'wc.refresh': 'Nei lad\'n',
    'wc.retry': 'Nomoi probier\'n',
    'wc.totalBookings': 'Alle Buchung\'n',
    'wc.today': 'Heid',
    'wc.wheelchairs': 'Rollstuihl',
    'wc.stations': 'Station\'n',
    'wc.filter': 'Filt\'a',
    'wc.fromDate': 'Vo wann', 'wc.toDate': 'Bis wann',
    'wc.resetFilter': 'Filt\'a z\'rücksetz\'n',
    'wc.bookings': 'Buchung\'n ({count})',
    'wc.noBookings': 'Koane Buchung\'n g\'fund\'n',
    'wc.noBookingsDesc': 'Für den Zeitraum gibts koane Buchung\'n.',
    'wc.id': 'ID', 'wc.customer': 'Gast', 'wc.phone': 'Telefon',
    'wc.date': 'Datum', 'wc.startTime': 'Start', 'wc.endTime': 'End',
    'wc.wheelchair': 'Rollstuihl', 'wc.station': 'Station',
    'wc.remarks': 'Anmerkung\'n', 'wc.actions': 'Was toa?',
    'wc.wheelchairNum': 'Rollstuihl {num}',
    'wc.save': 'Speich\'an', 'wc.cancelEdit': 'Doch ned', 'wc.edit': 'Änd\'an', 'wc.delete': 'Weg damit',
    'wc.confirmDelete': 'Wirkli lösch\'n, de Buchung?',
    'wc.loadingData': 'Lad\'t...', 'wc.loadError': 'Fehla beim Lad\'n',
    'wc.noBookingsForPeriod': 'Koa Buchung\'n für den Zeitraum g\'funden.',

    'wr.title': '🦽 Rollstuihl-Verleih Wiesn {year}',
    'wr.hours': 'Öffnungszeit\'n aufm Oktoberfest:',
    'wr.period': 'Verfügbar: 19.09.{year} - 04.10.{year}',
    'wr.step1': '1. Tog auswähl\'n',
    'wr.step2': '2. Uhrzeit auswähl\'n',
    'wr.step3': '3. Station & Rollstuihl wähl\'n',
    'wr.startTime': 'Startzeit:', 'wr.selectStart': 'Startzeit wähl\'n',
    'wr.endTime': 'Endzeit:', 'wr.selectEnd': 'Endzeit wähl\'n',
    'wr.name': 'Wia hoaßt du?:', 'wr.namePlaceholder': 'Dei ganzer Nam',
    'wr.emailLbl': 'E-Mail (optional):',
    'wr.phoneLbl': 'Telefon (freiwillig):', 'wr.phonePlaceholder': 'Dei Telefonumma',
    'wr.remarksLbl': 'Sonstigs (freiwillig):', 'wr.remarksPlaceholder': 'Wennst no was brauchst',
    'wr.hour': '{h}:00 Uhr',
    'wr.endOfDay': '24:00 Uhr (Tog\'s Ende)',
    'wr.selectTimeInfo': 'Wähl Start- und Endzeit fia {date}',
    'wr.checkingAvail': 'Schau ob\'s was gibt...',
    'wr.selectedPeriod': 'Dei Zeitraum:',
    'wr.availableWheelchairs': 'Verfügbare Rollstuihl ({count}):',
    'wr.wheelchairNum': 'Rollstuihl {num}',
    'wr.stationName': 'Station: {name}',
    'wr.bookNow': 'Jetzad buch\'n',
    'wr.booking': 'Wird bucht...',
    'wr.map': '(Kartn)',
    'wr.enterName': 'Sag erst wia du hoaßt',
    'wr.bookingSuccess': '✅ Basst, is bucht!',
    'wr.bookingError': 'Mei, des hod ned funktioniert',
    'wr.bookingSuccessMsg': 'Buchung fia {date} hod klappt!',
    'wr.newBooking': 'Neie Buchung',
    'wr.copyDetails': '📋 Details kopier\'n',
    'wr.copied': 'Buchungsdetails san kopiert!',
    'wr.bookingNum': 'Buchungsnumma:',
    'wr.bookingName': 'Nam:',
    'wr.bookingWheelchair': 'Rollstuihl:',
    'wr.bookingStation': 'Station:',
    'wr.bookingDate': 'Datum:',
    'wr.bookingTime': 'Zeit:',
    'wr.selectDateTime': 'Bittschön wähl Datum, Start- und Endzeit',
    'wr.endAfterStart': 'D\'Endzeit muass nach da Startzeit sei',
    'wr.enterNameAlert': 'Sag erst wia du hoaßt',
    'wr.availError': 'Fehla bei da Verfügbarkeitsprüfung',
    'wr.bookingErrorMsg': 'Fehla bei da Buchung',
    'wr.noWheelchairs': 'Koa Rollstuihl frei für de Zeit.',
    'wr.chooseOtherTimes': 'Bittschön wähl a andre Zeit.',
    'wr.unknownStation': 'Unbekannte Station',
    'wr.clock': 'Uhr',
    'wr.backToLogin': 'Zruck zum Login',
    'day.sunShort': 'So', 'day.monShort': 'Mo', 'day.tueShort': 'Di',
    'day.wedShort': 'Mi', 'day.thuShort': 'Do', 'day.friShort': 'Fr', 'day.satShort': 'Sa',

    'common.save': 'Speich\'an', 'common.cancel': 'Doch ned', 'common.delete': 'Weg damit',
    'common.edit': 'Änd\'an', 'common.close': 'Zua mach\'n', 'common.loading': 'Lad\'t...',
    'common.error': 'Fehla', 'common.success': 'Basst!', 'common.unknown': 'Unbekannt',

    // Contract Form
    'contract.title': 'Digitaler Arbeitsvertrag',
    'contract.loadTemplate': 'Mei Vorlag lad\'n',
    'contract.saving': 'Speichert...',
    'contract.save': 'Speich\'an',
    'contract.cancel': 'Doch ned',
    'contract.edit': 'Änd\'an',
    'contract.editContract': 'Vertrag änd\'an',
    'contract.fillContract': 'Vertrag ausfüll\'n',
    'contract.printPdf': 'Als PDF druck\'n',
    'contract.pleaseSelect': 'Bittschön wähl...',
    'contract.remove': 'Weg damit',
    'contract.addJob': 'Nochane Beschäftigung dazua',
    'contract.signDigitally': 'Digital unterschreib\'n',
    'contract.uploadImage': 'Buidl hochlad\'n',
    'contract.deleteSignature': 'Lösch\'n',
    'contract.finalize': 'Vertrag abschließ\'n',
    'contract.finalizeHint': 'Schau da ois nochmal an und reich den Vertrag ei.',
    'contract.submitting': 'Wird eigreicht...',
    'contract.submit': 'Vertrag eireich\'n',
    'contract.back': 'Zruck',
    'contract.saveDraft': 'Als Entwurf speich\'an',
    'contract.myContracts': 'Mei Verträg',
    'contract.hide': 'Versteck\'n',
    'contract.show': 'Zeig\'n',
    'contract.noContracts': 'No koane Verträg',
    'contract.restart': 'Nochmal',
    'contract.acceptSignature': 'Unterschrift nehma',
    'contract.signatureHint': 'Unterschreib mit da Maus oda am Finger do untn:',
    'contract.pdfLanguageNotice': 'Hinweis: Da Vertrag wird als PDF auf Deitsch erstellt.',
    'contract.pdfTranslationNotice': 'Hinweis: Da Vertrag wird als PDF auf Englisch erstellt.',
  },
};
